import React, { useEffect, useRef, useState } from 'react';
import { useMutation } from '@apollo/client';
import {
  Link,
  useParams,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router-dom';
import { Spin, Layout, Menu, Typography, Button, BackTop, Space } from 'antd';
import {
  PicCenterOutlined,
  DashboardOutlined,
  ControlOutlined,
  TeamOutlined,
  RollbackOutlined,
  ReconciliationOutlined,
  SlidersOutlined,
  EyeOutlined,
  CarryOutOutlined,
  HomeOutlined,
  DollarOutlined,
  UserOutlined,
  ShoppingOutlined,
  SkinOutlined,
  CalendarOutlined,
  BarcodeOutlined,
  ProfileOutlined,
  DribbbleOutlined,
  BorderlessTableOutlined,
  FormatPainterOutlined,
  PlaySquareOutlined,
  AuditOutlined,
  MailOutlined,
  ArrowUpOutlined,
  RedoOutlined,
  VideoCameraOutlined,
  TableOutlined,
  LoadingOutlined,
  MessageOutlined,
  UploadOutlined,
  AudioOutlined,
  UnorderedListOutlined,
  FileTextOutlined,
  UserAddOutlined,
  ShareAltOutlined,
  ScissorOutlined,
  UnlockOutlined,
  BarChartOutlined,
  TrophyOutlined,
  BellOutlined,
  SettingOutlined,
  SwapOutlined,
  MenuOutlined,
  CloseOutlined,
  ScheduleOutlined,
} from '@ant-design/icons';
// Api
import { SIGN_OUT } from 'api/auth/mutations';
// Types
import { UserRole } from 'api/graphql-global-types';
import { LocationStateType } from 'pages/StreamsCalendar/components/StreamsListItem/StreamsListItem';
import { SignOut, SignOutVariables } from 'api/auth/types/SignOut';
// Hooks
import { useAppContext, useTicketingLaunched } from 'hooks';
// Constants
import {
  LOGIN,
  HOME_PAGE_MANAGEMENT,
  DASHBOARD,
  TAGS,
  // MANAGE_MERCH_GEN,
  // MANAGE_MERCH,
  MANAGE_MERCH_TSHIRT_GEN,
  MANAGE_MERCH_HOODIE_GEN,
  MANAGE_MERCH_HAT_GEN,
  MANAGE_MERCH_JOGGERS_GEN,
  MANAGE_MERCH_RASH_GUARD_GEN,
  MANAGE_MERCH_TSHIRT,
  MANAGE_MERCH_HOODIE,
  MANAGE_MERCH_HAT,
  MANAGE_MERCH_JOGGERS,
  MANAGE_MERCH_RASH_GUARD,
  MANAGE_ATHLETES_STORES,
  MANAGE_ATHLETES_STORES_WITH_PAGINATION,
  ATHLETE_DASHBOARD,
  ATHLETE_DASHBOARD_GEN,
  MANAGE_ATHLETE_AMA_REQUESTS_GEN,
  MANAGE_ATHLETE_AMA_REQUESTS,
  MANAGE_ATHLETE_SCHEDULED_STREAMS,
  MANAGE_ATHLETE_SCHEDULED_STREAMS_GEN,
  SETUP_ATHLETE_STREAM_GEN,
  SETUP_ATHLETE_STREAM,
  SETUP_ATHLETE_AMA_GEN,
  SETUP_ATHLETE_AMA,
  ATHLETE_DEALS_SETUP_GEN,
  ATHLETE_DEALS_SETUP,
  MANAGE_ATHLETE_MERCH_GEN,
  MANAGE_ATHLETE_MERCH,
  MANAGE_ATHLETE_PRODUCTS_GEN,
  MANAGE_ATHLETE_PRODUCTS,
  MANAGE_ATHLETE_EXPERIENCE_GEN,
  MANAGE_ATHLETE_EXPERIENCE,
  MANAGE_ATHLETE_DESIGNS_GEN,
  MANAGE_ATHLETE_DESIGNS,
  MANAGE_ATHLETE_BIO_GEN,
  MANAGE_ATHLETE_BIO,
  MEDIA_FEED_ATHLETE_GEN,
  MEDIA_FEED_ATHLETE,
  ATHLETE_STORE_SALES_GEN,
  ATHLETE_SCHEDULED_EVENTS_GEN,
  ATHLETE_SCHEDULED_EVENTS,
  ORGANIZATION_SCHEDULED_EVENTS_GEN,
  ORGANIZATION_SCHEDULED_EVENTS,
  CONTENT_CREATOR_SCHEDULED_EVENTS_GEN,
  CONTENT_CREATOR_SCHEDULED_EVENTS,
  ATHLETE_STORE_SALES,
  CUSTOMERS,
  MANAGE_ACCOUNT,
  CUSTOMERS_WITH_PAGINATION,
  CUSTOMER_PURCHASES_GEN,
  CUSTOMER_PURCHASES,
  CUSTOMER_SETTINGS_GEN,
  CUSTOMER_SETTINGS,
  CUSTOMER_ADDRESSES_GEN,
  CUSTOMER_ADDRESSES,
  CUSTOMER_PAYMENT_GEN,
  CUSTOMER_PAYMENT,
  ALL_PRODUCT_MEMORABILIA,
  ALL_AMA_REQUESTS,
  STREAMS_CALENDAR,
  ALL_STREAMS_TABLE,
  WATCH_STREAM,
  PROMO_CODES,
  DESIGN_REQUESTS,
  DESIGNERS,
  EDITING_REQUESTS,
  MY_EDITING_REQUESTS,
  VIDEO_EDITORS,
  VIDEO_EDITOR_PROFILE,
  MY_DESIGN_REQUESTS,
  REDIRECTS,
  GENERAL_SALES,
  EXPERIENCE_SALES,
  WATCH_STREAM_GEN,
  MERCH_SALES_REPORT,
  AMA_SALES_REPORT,
  STREAM_SALES_REPORT,
  AFFILIATE_COMMISSIONS_REPORT,
  AFFILIATE_STREAMS,
  MANAGE_WATCH_STREAM_MODERATORS_GEN,
  LIST_OF_ASSIGNED_STREAMS,
  ADMINS,
  ACCOUNT,
  DESIGN_REQUEST_RESULT_DETAILS,
  DESIGN_REQUEST_DETAILS,
  DESIGN_REQUEST_DETAILS_GEN,
  DESIGN_REQUEST_RESULT_DETAILS_GEN,
  MANAGE_MESSAGES,
  MANAGE_MESSAGES_WITH_PAGINATION,
  CAMPAIGNS,
  CAMPAIGN_DETAILS,
  CAMPAIGN_DETAILS_GEN,
  BRANDS,
  BRANDS_WITH_PAGINATION,
  BRAND_DETAILS,
  BILLING,
  CB_SETTINGS,
  CB_SETTINGS_GEN,
  CB_TEAM_OWNERSHIP,
  CB_TEAM_OWNERSHIP_GEN,
  CB_PROMO_CODES,
  CB_DIGITAL_AGREEMENT_SETTINGS,
  CB_SIGN_UP_SETTINGS,
  BRAND_PREFERENCES,
  BRAND_PREFERENCES_GEN,
  CREDIT_USAGE_REPORT,
  CREDIT_USAGE_REPORT_WITH_PAGINATION,
  CREDIT_USAGE_DETAILS,
  CREDIT_USAGE_DETAILS_GEN,
  INFLUENCER_CATEGORIES,
  PRODUCT_CATEGORIES,
  RESTRICTED_CATEGORIES,
  MANAGE_CONTENT_CREATOR_PRODUCTS_GEN,
  MANAGE_CONTENT_CREATOR_EXPERIENCE_GEN,
  MANAGE_ORGANIZATION_EXPERIENCE_GEN,
  MANAGE_ORGANIZATION_PRODUCTS_GEN,
  MANAGE_ORGANIZATIONS_STORES,
  ORGANIZATION_DASHBOARD_GEN,
  MANAGE_ORGANIZATION_AMA_REQUESTS_GEN,
  MANAGE_ORGANIZATION_SCHEDULED_STREAMS_GEN,
  SETUP_ORGANIZATION_AMA_GEN,
  SETUP_ORGANIZATION_STREAM_GEN,
  MANAGE_ORGANIZATION_MERCH_GEN,
  MANAGE_ORGANIZATION_DESIGNS_GEN,
  MANAGE_ORGANIZATION_BIO_GEN,
  MEDIA_FEED_ORGANIZATION_GEN,
  ORGANIZATION_STORE_SALES_GEN,
  MANAGE_ORGANIZATION_PRODUCTS,
  MANAGE_ORGANIZATION_EXPERIENCE,
  MANAGE_CONTENT_CREATOR_PRODUCTS,
  MANAGE_CONTENT_CREATOR_EXPERIENCE,
  MANAGE_ORGANIZATIONS_STORES_WITH_PAGINATION,
  ORGANIZATION_DASHBOARD,
  MANAGE_ORGANIZATION_AMA_REQUESTS,
  MANAGE_ORGANIZATION_SCHEDULED_STREAMS,
  SETUP_ORGANIZATION_STREAM,
  SETUP_ORGANIZATION_AMA,
  MANAGE_ORGANIZATION_MERCH,
  MANAGE_ORGANIZATION_DESIGNS,
  MANAGE_ORGANIZATION_BIO,
  MEDIA_FEED_ORGANIZATION,
  ORGANIZATION_STORE_SALES,
  MANAGE_CONTENT_CREATORS_STORES_WITH_PAGINATION,
  EXTERNAL_TALENTS,
  EXTERNAL_TALENT_IMPORT,
  CONTENT_CREATOR_DASHBOARD_GEN,
  CONTENT_CREATOR_DASHBOARD,
  MANAGE_CONTENT_CREATOR_AMA_REQUESTS,
  MANAGE_CONTENT_CREATOR_SCHEDULED_STREAMS,
  MANAGE_CONTENT_CREATOR_MERCH,
  MANAGE_CONTENT_CREATOR_MERCH_GEN,
  SETUP_CONTENT_CREATOR_AMA,
  CONTENT_CREATOR_DEALS_SETUP,
  SETUP_CONTENT_CREATOR_STREAM,
  MANAGE_CONTENT_CREATOR_DESIGNS_GEN,
  MANAGE_CONTENT_CREATOR_DESIGNS,
  MANAGE_CONTENT_CREATOR_BIO_GEN,
  MANAGE_CONTENT_CREATOR_BIO,
  MEDIA_FEED_CONTENT_CREATOR_GEN,
  MEDIA_FEED_CONTENT_CREATOR,
  CONTENT_CREATOR_STORE_SALES_GEN,
  CONTENT_CREATOR_STORE_SALES,
  MANAGE_CONTENT_CREATORS_STORES,
  MANAGE_CONTENT_CREATOR_AMA_REQUESTS_GEN,
  MANAGE_CONTENT_CREATOR_SCHEDULED_STREAMS_GEN,
  SETUP_CONTENT_CREATOR_AMA_GEN,
  CONTENT_CREATOR_DEALS_SETUP_GEN,
  SETUP_CONTENT_CREATOR_STREAM_GEN,
  BULK_UPLOAD,
  MANUAL_MERCH_MERGE,
  INTERVIEWS,
  INTERVIEW_CHATS,
  INTERVIEWERS,
  INTERVIEW_SETTINGS,
  INTERVIEW_NOW_TRANSITIONS,
  INTERVIEW_NOW_NOTIFICATIONS,
  CHANNEL_MONETIZATION,
  CHANNEL_MONETIZATION_APPLICATIONS,
  CHANNEL_MONETIZATION_LEADERBOARD,
  FEATURE_LIMITS,
  ACTIVE_FEATURE_LIMITS,
  AUDIT_LOGS,
  MY_INTERVIEWS,
  MY_SCHEDULED_EVENTS,
  MY_AVAILABILITY,
  VIDEO_EDIT_REQUEST_SETTINGS,
  SOCIAL_MEDIA_INTEGRATION_SETTINGS,
  ARTICLES,
  ARTICLES_WITH_PAGINATION,
  AI_CLIPS,
  AI_CLIP_DETAIL_GEN,
  AI_CLIP_DETAIL,
  AI_CLIPPER_METRICS,
  AI_CLIPPER_SETTINGS,
  AI_POST_CLIPS,
  AI_POST_CLIP_DETAIL_GEN,
  AI_POST_CLIP_DETAIL,
  AI_PPV_CLIPS,
  PPV_CLIP_ANALYTICS,
  PPV_AUTO_FREE_SETTINGS,
  AI_PPV_CLIP_DETAIL_GEN,
  AI_PPV_CLIP_DETAIL,
  CREATE_PROFILE,
  FEATURED_STREAMS,
  BILLING_GEN,
  BRAND_DETAILS_GEN,
  MANAGE_ATHLETE_MARGINS_GEN,
  MANAGE_ATHLETE_MARGINS,
  MANAGE_ORGANIZATION_MARGINS_GEN,
  MANAGE_ORGANIZATION_MARGINS,
  MANAGE_CONTENT_CREATOR_MARGINS_GEN,
  MANAGE_CONTENT_CREATOR_MARGINS,
  EVENTS_WITH_TABS,
  TICKETING_SETTINGS,
  ENGAGEMENT_NOTIFICATION_SETTINGS,
  CREATE_TICKET_EVENT,
  EDIT_TICKET_EVENT,
  EDIT_TICKET_EVENT_GEN,
  TICKET_EVENT_DETAILS,
  TICKET_EVENT_DETAILS_GEN,
  ATHLETE_TICKETED_EVENTS_GEN,
  ATHLETE_TICKETED_EVENTS,
  ORGANIZATION_TICKETED_EVENTS_GEN,
  ORGANIZATION_TICKETED_EVENTS,
  CONTENT_CREATOR_TICKETED_EVENTS_GEN,
  CONTENT_CREATOR_TICKETED_EVENTS,
} from 'constants/routes';
import {
  CUSTOMERS_DEFAULT_ROUTE,
  ARTICLES_DEFAULT_ROUTE,
  EVENTS_DEFAULT_ROUTE,
  MANAGE_ATHLETES_STORES_DEFAULT_ROUTE,
  MANAGE_MESSAGES_DEFAULT_ROUTE,
  MANAGE_ORGANIZATIONS_STORES_DEFAULT_ROUTE,
  MANAGE_CONTENT_CREATORS_STORES_DEFAULT_ROUTE,
} from 'App';
import { STORE_TYPE } from 'constants/global';
// Components
import LoginForm from 'components/common/LoginForm/LoginForm';
import { WorkspaceNavigation } from 'ui/WorkspaceNavigation';
// Styles
import styles from './LayoutWrapper.module.scss';

const { Sider, Header, Content } = Layout;
const { Title } = Typography;
const { SubMenu } = Menu;

type State = {
  collapsed: boolean | false;
};

export const LAYOUT_ID = 'right-side-layout';

const MENU_ITEMS: Record<string, string> = {
  HOME_PAGE_MANAGEMENT: 'homePageManagement',
  FEATURED_STREAMS: 'featuredStreams',
  DASHBOARD: 'dashboard',
  TAGS: 'tags',

  // MANAGE_MERCH_GEN: 'manageMerchGen',
  // MANAGE_MERCH: 'manageMerch',
  MANAGE_MERCH_TSHIRT_GEN: 'manageMerchTShirtGen',
  MANAGE_MERCH_TSHIRT: 'manageMerchTShirt',
  MANAGE_MERCH_HOODIE_GEN: 'manageMerchHoodieGen',
  MANAGE_MERCH_HOODIE: 'manageMerchHoodie',
  MANAGE_MERCH_HAT_GEN: 'manageMerchHatGen',
  MANAGE_MERCH_HAT: 'manageMerchHat',
  MANAGE_MERCH_JOGGERS_GEN: 'manageMerchJoggersGen',
  MANAGE_MERCH_JOGGERS: 'manageMerchJoggers',
  MANAGE_MERCH_RASH_GUARD_GEN: 'manageMerchRashGuardGen',
  MANAGE_MERCH_RASH_GUARD: 'manageMerchRashGuard',

  MANAGE_ATHLETES_STORES: 'manageAthletesStoreS',
  MANAGE_ATHLETES_STORES_WITH_PAGINATION: 'manageAthletesStoresWithPagination',
  ATHLETE_DASHBOARD_GEN: 'athleteDashboardGen',
  ATHLETE_DASHBOARD: 'athleteDashboard',
  MANAGE_ATHLETE_AMA_REQUESTS: 'manageAthleteAmaRequests',
  MANAGE_ATHLETE_SCHEDULED_STREAMS: 'manageAthleteScheduledStreams',
  SETUP_ATHLETE_STREAM: 'setupAthleteStream',
  SETUP_ATHLETE_AMA: 'setupAthleteAma',
  ATHLETE_DEALS_SETUP: 'athleteDealsSetup',
  MANAGE_ATHLETE_MERCH_GEN: 'manageAthleteMerchGen',
  MANAGE_ATHLETE_DESIGNS_GEN: 'manageAthleteDesignsGen',
  MANAGE_ATHLETE_MERCH: 'manageAthleteMerch',
  MANAGE_ATHLETE_MARGINS_GEN: 'manageAthleteMarginsGen',
  MANAGE_ATHLETE_MARGINS: 'manageAthleteMargins',
  MANAGE_ATHLETE_PRODUCTS_GEN: 'manageAthleteProductsGen',
  MANAGE_ATHLETE_PRODUCTS: 'manageAthleteProducts',
  MANAGE_ATHLETE_EXPERIENCE_GEN: 'manageAthleteExperienceGen',
  MANAGE_ATHLETE_EXPERIENCE: 'manageAthleteExperience',

  MANAGE_ORGANIZATION_PRODUCTS_GEN: 'manageOrganizationProductsGen',
  MANAGE_ORGANIZATION_PRODUCTS: 'manageOrganizationProducts',
  MANAGE_ORGANIZATION_EXPERIENCE_GEN: 'manageOrganizationExperienceGen',
  MANAGE_ORGANIZATION_EXPERIENCE: 'manageOrganizationExperience',
  MANAGE_ORGANIZATION_MARGINS_GEN: 'manageOrganizationMarginsGen',
  MANAGE_ORGANIZATION_MARGINS: 'manageOrganizationMargins',

  MANAGE_CONTENT_CREATOR_PRODUCTS_GEN: 'manageContentCreatorProductsGen',
  MANAGE_CONTENT_CREATOR_PRODUCTS: 'manageContentCreatorProducts',
  MANAGE_CONTENT_CREATOR_EXPERIENCE_GEN: 'manageContentCreatorExperienceGen',
  MANAGE_CONTENT_CREATOR_EXPERIENCE: 'manageContentCreatorExperience',
  MANAGE_CONTENT_CREATOR_MARGINS_GEN: 'manageContentCreatorMarginsGen',
  MANAGE_CONTENT_CREATOR_MARGINS: 'manageContentCreatorMargins',
  EXTERNAL_TALENTS: 'externalTalents',
  EXTERNAL_TALENT_IMPORT: 'externalTalentImport',

  MANAGE_ATHLETE_DESIGNS: 'manageAthleteDesigns',
  MANAGE_ATHLETE_BIO_GEN: 'manageAthleteBioGen',
  MANAGE_ATHLETE_BIO: 'manageAthleteBio',
  MEDIA_FEED_ATHLETE_GEN: 'mediaFeedAthleteGen',
  MEDIA_FEED_ATHLETE: 'mediaFeedAthlete',
  ATHLETE_STORE_SALES_GEN: 'athleteStoreSalesGen',
  ATHLETE_STORE_SALES: 'athleteStoreSales',

  ATHLETE_SCHEDULED_EVENTS_GEN: 'athleteScheduledEventsGen',
  ATHLETE_SCHEDULED_EVENTS: 'athleteScheduledEvents',

  ORGANIZATION_SCHEDULED_EVENTS_GEN: 'organizationScheduledEventsGen',
  ORGANIZATION_SCHEDULED_EVENTS: 'organizationScheduledEvents',
  ATHLETE_TICKETED_EVENTS: 'athleteTicketedEvents',
  ORGANIZATION_TICKETED_EVENTS: 'organizationTicketedEvents',
  CONTENT_CREATOR_TICKETED_EVENTS: 'contentCreatorTicketedEvents',
  EVENTS_WITH_TABS: 'eventsWithTabs',
  TICKETING_SETTINGS: 'ticketingSettings',
  ENGAGEMENT_NOTIFICATION_SETTINGS: 'engagementNotificationSettings',

  CONTENT_CREATOR_SCHEDULED_EVENTS_GEN: 'contentCreatorScheduledEventsGen',
  CONTENT_CREATOR_SCHEDULED_EVENTS: 'contentCreatorScheduledEvents',

  MANAGE_ORGANIZATION_STORES: 'manageOrganizationStores',
  MANAGE_ORGANIZATIONS_STORES_WITH_PAGINATION:
    'manageOrganizationStoresWithPagination',
  ORGANIZATION_DASHBOARD_GEN: 'organizationDashboardGen',
  ORGANIZATION_DASHBOARD: 'organizationDashboard',
  MANAGE_ORGANIZATION_AMA_REQUESTS: 'manageOrganizationAmaRequests',
  MANAGE_ORGANIZATION_SCHEDULED_STREAMS: 'manageOrganizationScheduledStreams',
  SETUP_ORGANIZATION_STREAM: 'setupOrganizationStream',
  SETUP_ORGANIZATION_AMA: 'setupOrganizationAma',
  MANAGE_ORGANIZATION_MERCH_GEN: 'manageOrganizationMerchGen',
  MANAGE_ORGANIZATION_DESIGNS_GEN: 'manageOrganizationDesignsGen',
  MANAGE_ORGANIZATION_MERCH: 'manageOrganizationMerch',
  MANAGE_ORGANIZATION_DESIGNS: 'manageOrganizationDesigns',
  MANAGE_ORGANIZATION_BIO_GEN: 'manageOrganizationBioGen',
  MANAGE_ORGANIZATION_BIO: 'manageOrganizationBio',
  MEDIA_FEED_ORGANIZATION_GEN: 'mediaFeedOrganizationGen',
  MEDIA_FEED_ORGANIZATION: 'mediaFeedOrganization',
  ORGANIZATION_STORE_SALES_GEN: 'organizationStoreSalesGen',
  ORGANIZATION_STORE_SALES: 'organizationStoreSales',

  MANAGE_CONTENT_CREATOR_STORES: 'manageContentCreatorStores',
  MANAGE_CONTENT_CREATORS_STORES_WITH_PAGINATION:
    'manageContentCreatorStoresWithPagination',
  CONTENT_CREATOR_DASHBOARD_GEN: 'contentCreatorDashboardGen',
  CONTENT_CREATOR_DASHBOARD: 'contentCreatorDashboard',
  MANAGE_CONTENT_CREATOR_AMA_REQUESTS: 'manageContentCreatorAmaRequests',
  MANAGE_CONTENT_CREATOR_SCHEDULED_STREAMS:
    'manageContentCreatorScheduledStreams',
  SETUP_CONTENT_CREATOR_STREAM: 'setupContentCreatorStream',
  SETUP_CONTENT_CREATOR_AMA: 'setupContentCreatorAma',
  CONTENT_CREATOR_DEALS_SETUP: 'contentCreatorDealsSetup',
  MANAGE_CONTENT_CREATOR_MERCH_GEN: 'manageContentCreatorMerchGen',
  MANAGE_CONTENT_CREATOR_DESIGNS_GEN: 'manageContentCreatorDesignsGen',
  MANAGE_CONTENT_CREATOR_MERCH: 'manageContentCreatorMerch',
  MANAGE_CONTENT_CREATOR_DESIGNS: 'manageContentCreatorDesigns',
  MANAGE_CONTENT_CREATOR_BIO_GEN: 'manageContentCreatorBioGen',
  MANAGE_CONTENT_CREATOR_BIO: 'manageContentCreatorBio',
  MEDIA_FEED_CONTENT_CREATOR_GEN: 'mediaFeedContentCreatorGen',
  MEDIA_FEED_CONTENT_CREATOR: 'mediaFeedContentCreator',
  CONTENT_CREATOR_STORE_SALES_GEN: 'contentCreatorStoreSalesGen',
  CONTENT_CREATOR_STORE_SALES: 'contentCreatorStoreSales',

  CUSTOMERS: 'customers',
  CUSTOMERS_WITH_PAGINATION: 'customersWithPagination',
  CUSTOMER_PURCHASES_GEN: 'customerPurchasesGen',
  CUSTOMER_PURCHASES: 'customerPurchases',
  CUSTOMER_SETTINGS_GEN: 'customerSettingsGen',
  CUSTOMER_SETTINGS: 'customerSettings',
  CUSTOMER_ADDRESSES_GEN: 'customerAddressesGen',
  CUSTOMER_ADDRESSES: 'customerAddresses',
  CUSTOMER_PAYMENT_GEN: 'customerPaymentGen',
  CUSTOMER_PAYMENT: 'customerPayment',

  ALL_PRODUCT_MEMORABILIA: 'allProductMemorabilia',

  ALL_AMA_REQUESTS: 'allAmaRequests',

  STREAMS_CALENDAR: 'streamsCalendar',
  ALL_STREAMS_TABLE: 'allStreamsTable',
  MANAGE_WATCH_STREAM_MODERATORS_GEN: 'manageModerators',
  WATCH_STREAM_GEN: 'watchStreamGen',
  WATCH_STREAM: 'watchStream',

  PROMO_CODES: 'promoCodes',
  BULK_UPLOAD: 'bulkUpload',
  DESIGN_REQUESTS: 'designRequests',
  DESIGNERS: 'designersList',
  GENERAL_SALES: 'generalSales',
  EXPERIENCE_SALES: 'experienceSales',
  MANAGE_MESSAGES: 'manageMessages',
  MANAGE_MESSAGES_WITH_PAGINATION: 'manageMessagesWithPagination',
  CAMPAIGNS: 'Campaigns',
  BRANDS: 'Brands',
  BRAND_DETAILS: 'brandDetails',
  BILLING: 'Billing',
  CB_SETTINGS: 'cbSettings',
  CB_TEAM_OWNERSHIP: 'cbTeamOwnership',
  CB_PROMO_CODES: 'cbPromoCodes',
  CB_DIGITAL_AGREEMENT_SETTINGS: 'cbDigitalAgreementSettings',
  CB_SIGN_UP_SETTINGS: 'cbSignUpSettings',
  BRAND_PREFERENCES: 'brandPreferences',
  CREDIT_USAGE_REPORT: 'creditUsageReport',
  CREDIT_USAGE_DETAILS: 'creditUsageDetails',
  INFLUENCER_CATEGORIES: 'influencerCategories',
  PRODUCT_CATEGORIES: 'productCategories',
  RESTRICTED_CATEGORIES: 'restrictedCategories',
  CAMPAIGN_DETAILS: 'campaignDetails',
  CAMPAIGN_DETAILS_GEN: 'campaignDetailsGen',
  ADMINS: 'Admins',

  EDITING_REQUESTS: 'editingRequests',
  MY_EDITING_REQUESTS: 'myEditingRequest',
  VIDEO_EDITORS: 'videoEditors',
  VIDEO_EDITOR_PROFILE: 'videoEditorProfile',
  MY_DESIGN_REQUESTS: 'myDesignRequests',
  VIDEO_EDIT_REQUEST_SETTINGS: 'videoEditRequestSettings',

  REDIRECTS: 'redirects',

  MERCH_SALES_REPORT: 'athleteSalesReport',
  AMA_SALES_REPORT: 'amaSalesReport',
  STREAM_SALES_REPORT: 'streamSalesReport',
  AFFILIATE_COMMISSIONS_REPORT: 'affiliateCommissionsReport',
  AFFILIATE_STREAMS: 'affiliateStreams',

  LIST_OF_ASSIGNED_STREAMS: 'list-of-assigned-streams',
  MANUAL_MERCH_MERGE: 'manualMerchMerge',
  INTERVIEWS: 'interviews',
  INTERVIEW_CHATS: 'interviewChats',
  INTERVIEWERS: 'interviewers',
  INTERVIEW_SETTINGS: 'interviewSettings',
  INTERVIEW_NOW_TRANSITIONS: 'interviewNowTransitions',
  INTERVIEW_NOW_NOTIFICATIONS: 'interviewNowNotifications',
  CHANNEL_MONETIZATION: 'channelMonetization',
  CHANNEL_MONETIZATION_APPLICATIONS: 'channelMonetizationApplications',
  CHANNEL_MONETIZATION_LEADERBOARD: 'channelMonetizationLeaderboard',
  FEATURE_LIMITS: 'featureLimits',
  ACTIVE_FEATURE_LIMITS: 'activeFeatureLimits',
  AUDIT_LOGS: 'auditLogs',
  MY_SCHEDULE_EVENTS: 'myScheduleEvents',
  MY_AVAILABILITY: 'availability',
  MY_INTERVIEWS: 'myInterviews',
  MY_SCHEDULED_EVENTS: 'myScheduledEvents',

  AI_CLIPS: 'aiClips',
  AI_CLIP_DETAIL_GEN: 'aiClipDetailGen',
  AI_CLIP_DETAIL: 'aiClipDetail',
  AI_CLIPPER_METRICS: 'aiClipperMetrics',
  AI_CLIPPER_SETTINGS: 'aiClipperSettings',
  AI_POST_CLIPS: 'aiPostClips',
  AI_POST_CLIP_DETAIL_GEN: 'aiPostClipDetailGen',
  AI_POST_CLIP_DETAIL: 'aiPostClipDetail',

  AI_PPV_CLIPS: 'aiPpvClips',
  PPV_CLIP_ANALYTICS: 'ppvClipAnalytics',
  PPV_AUTO_FREE_SETTINGS: 'ppvAutoFreeSettings',
  AI_PPV_CLIP_DETAIL_GEN: 'aiPpvClipDetailGen',
  AI_PPV_CLIP_DETAIL: 'aiPpvClipDetail',

  ARTICLES: 'articles',
  ARTICLES_WITH_PAGINATION: 'articlesWithPagination',
  CREATE_PROFILE: 'createProfile',
  SOCIAL_MEDIA_INTEGRATION_SETTINGS: 'socialMediaIntegrationSettings',
};

const MERCH_MENU_ITEMS: string[] = [
  // MENU_ITEMS.MANAGE_MERCH,
  MENU_ITEMS.MANAGE_MERCH_TSHIRT_GEN,
  MENU_ITEMS.MANAGE_MERCH_TSHIRT,
  MENU_ITEMS.MANAGE_MERCH_HOODIE_GEN,
  MENU_ITEMS.MANAGE_MERCH_HOODIE,
  MENU_ITEMS.MANAGE_MERCH_HAT_GEN,
  MENU_ITEMS.MANAGE_MERCH_HAT,
  MENU_ITEMS.MANAGE_MERCH_JOGGERS_GEN,
  MENU_ITEMS.MANAGE_MERCH_JOGGERS,
  MENU_ITEMS.MANAGE_MERCH_RASH_GUARD_GEN,
  MENU_ITEMS.MANAGE_MERCH_RASH_GUARD,
];

const ATHLETE_MENU_ITEMS: string[] = [
  MENU_ITEMS.ATHLETE_DASHBOARD_GEN,
  MENU_ITEMS.ATHLETE_DASHBOARD,
  MENU_ITEMS.MANAGE_ATHLETE_MARGINS_GEN,
  MENU_ITEMS.MANAGE_ATHLETE_MARGINS,
  MENU_ITEMS.MANAGE_ATHLETE_MERCH,
  ...MERCH_MENU_ITEMS,
  MENU_ITEMS.MANAGE_ATHLETE_DESIGNS,
  MENU_ITEMS.MANAGE_ATHLETE_AMA_REQUESTS,
  MENU_ITEMS.SETUP_ATHLETE_AMA,
  MENU_ITEMS.ATHLETE_DEALS_SETUP,
  MENU_ITEMS.MANAGE_ATHLETE_SCHEDULED_STREAMS,
  MENU_ITEMS.SETUP_ATHLETE_STREAM,
  MENU_ITEMS.MANAGE_ATHLETE_PRODUCTS,
  MENU_ITEMS.MANAGE_ATHLETE_EXPERIENCE,

  MENU_ITEMS.MANAGE_ATHLETE_BIO,
  MENU_ITEMS.MEDIA_FEED_ATHLETE,
  MENU_ITEMS.ATHLETE_STORE_SALES,
  MENU_ITEMS.ATHLETE_SCHEDULED_EVENTS,
  MENU_ITEMS.ATHLETE_TICKETED_EVENTS,
];

const ORGANIZATION_MENU_ITEMS: string[] = [
  MENU_ITEMS.ORGANIZATION_DASHBOARD_GEN,
  MENU_ITEMS.ORGANIZATION_DASHBOARD,
  MENU_ITEMS.MANAGE_ORGANIZATION_MARGINS_GEN,
  MENU_ITEMS.MANAGE_ORGANIZATION_MARGINS,
  MENU_ITEMS.MANAGE_ORGANIZATION_MERCH,
  ...MERCH_MENU_ITEMS,
  MENU_ITEMS.MANAGE_ORGANIZATION_DESIGNS,
  MENU_ITEMS.MANAGE_ORGANIZATION_AMA_REQUESTS,
  MENU_ITEMS.SETUP_ORGANIZATION_AMA,
  MENU_ITEMS.MANAGE_ORGANIZATION_SCHEDULED_STREAMS,
  MENU_ITEMS.SETUP_ORGANIZATION_STREAM,
  MENU_ITEMS.MANAGE_ORGANIZATION_PRODUCTS,
  MENU_ITEMS.MANAGE_ORGANIZATION_EXPERIENCE,

  MENU_ITEMS.MANAGE_ORGANIZATION_BIO,
  MENU_ITEMS.MEDIA_FEED_ORGANIZATION,
  MENU_ITEMS.ORGANIZATION_STORE_SALES,
  MENU_ITEMS.ORGANIZATION_SCHEDULED_EVENTS,
  MENU_ITEMS.ORGANIZATION_TICKETED_EVENTS,
];

const CONTENT_CREATOR_MENU_ITEMS: string[] = [
  MENU_ITEMS.CONTENT_CREATOR_DASHBOARD_GEN,
  MENU_ITEMS.CONTENT_CREATOR_DASHBOARD,
  MENU_ITEMS.MANAGE_CONTENT_CREATOR_MARGINS_GEN,
  MENU_ITEMS.MANAGE_CONTENT_CREATOR_MARGINS,
  MENU_ITEMS.MANAGE_CONTENT_CREATOR_MERCH,
  ...MERCH_MENU_ITEMS,
  MENU_ITEMS.MANAGE_CONTENT_CREATOR_DESIGNS,
  MENU_ITEMS.MANAGE_CONTENT_CREATOR_AMA_REQUESTS,
  MENU_ITEMS.SETUP_CONTENT_CREATOR_AMA,
  MENU_ITEMS.CONTENT_CREATOR_DEALS_SETUP,
  MENU_ITEMS.MANAGE_CONTENT_CREATOR_SCHEDULED_STREAMS,
  MENU_ITEMS.SETUP_CONTENT_CREATOR_STREAM,
  MENU_ITEMS.MANAGE_CONTENT_CREATOR_PRODUCTS,
  MENU_ITEMS.MANAGE_CONTENT_CREATOR_EXPERIENCE,

  MENU_ITEMS.MANAGE_CONTENT_CREATOR_BIO,
  MENU_ITEMS.MEDIA_FEED_CONTENT_CREATOR,
  MENU_ITEMS.CONTENT_CREATOR_STORE_SALES,
  MENU_ITEMS.CONTENT_CREATOR_SCHEDULED_EVENTS,
  MENU_ITEMS.CONTENT_CREATOR_TICKETED_EVENTS,
];

// TODO: uncomment it when "Watch Stream" menu will have at least one menu item
// const WATCH_STREAM_MENU_ITEMS: string[] = [
//   MENU_ITEMS.WATCH_STREAM_GEN,
//   MENU_ITEMS.WATCH_STREAM,
// ];

const CUSTOMER_MENU_ITEMS: string[] = [
  MENU_ITEMS.CUSTOMER_PURCHASES,
  MENU_ITEMS.CUSTOMER_SETTINGS,
  MENU_ITEMS.CUSTOMER_ADDRESSES,
  MENU_ITEMS.CUSTOMER_PAYMENT,
];

const MENU_ITEMS_LINKS: Record<string, string> = {
  [MENU_ITEMS.HOME_PAGE_MANAGEMENT]: HOME_PAGE_MANAGEMENT,
  [MENU_ITEMS.FEATURED_STREAMS]: FEATURED_STREAMS,
  [MENU_ITEMS.DASHBOARD]: DASHBOARD,
  [MENU_ITEMS.TAGS]: TAGS,

  // [MENU_ITEMS.MANAGE_MERCH_GEN]: MANAGE_MERCH_GEN,
  // [MENU_ITEMS.MANAGE_MERCH]: MANAGE_MERCH_GEN,
  [MENU_ITEMS.MANAGE_MERCH_TSHIRT_GEN]: MANAGE_MERCH_TSHIRT_GEN,
  [MENU_ITEMS.MANAGE_MERCH_TSHIRT]: MANAGE_MERCH_TSHIRT,
  [MENU_ITEMS.MANAGE_MERCH_HOODIE_GEN]: MANAGE_MERCH_HOODIE_GEN,
  [MENU_ITEMS.MANAGE_MERCH_HOODIE]: MANAGE_MERCH_HOODIE,
  [MENU_ITEMS.MANAGE_MERCH_HAT_GEN]: MANAGE_MERCH_HAT_GEN,
  [MENU_ITEMS.MANAGE_MERCH_HAT]: MANAGE_MERCH_HAT,
  [MENU_ITEMS.MANAGE_MERCH_JOGGERS_GEN]: MANAGE_MERCH_JOGGERS_GEN,
  [MENU_ITEMS.MANAGE_MERCH_JOGGERS]: MANAGE_MERCH_JOGGERS,
  [MENU_ITEMS.MANAGE_MERCH_RASH_GUARD_GEN]: MANAGE_MERCH_RASH_GUARD_GEN,
  [MENU_ITEMS.MANAGE_MERCH_RASH_GUARD]: MANAGE_MERCH_RASH_GUARD,

  [MENU_ITEMS.MANAGE_ATHLETES_STORES]: MANAGE_ATHLETES_STORES,
  [MENU_ITEMS.ATHLETE_DASHBOARD_GEN]: ATHLETE_DASHBOARD_GEN,
  [MENU_ITEMS.ATHLETE_DASHBOARD]: ATHLETE_DASHBOARD_GEN,
  [MENU_ITEMS.MANAGE_ATHLETE_MARGINS_GEN]: MANAGE_ATHLETE_MARGINS_GEN,
  [MENU_ITEMS.MANAGE_ATHLETE_MARGINS]: MANAGE_ATHLETE_MARGINS_GEN,
  [MENU_ITEMS.MANAGE_ATHLETE_AMA_REQUESTS]: MANAGE_ATHLETE_AMA_REQUESTS_GEN,
  [MENU_ITEMS.MANAGE_ATHLETE_SCHEDULED_STREAMS]:
    MANAGE_ATHLETE_SCHEDULED_STREAMS_GEN,
  [MENU_ITEMS.SETUP_ATHLETE_AMA]: SETUP_ATHLETE_AMA_GEN,
  [MENU_ITEMS.ATHLETE_DEALS_SETUP]: ATHLETE_DEALS_SETUP_GEN,
  [MENU_ITEMS.SETUP_ATHLETE_STREAM]: SETUP_ATHLETE_STREAM_GEN,
  [MENU_ITEMS.MANAGE_ATHLETE_MERCH_GEN]: MANAGE_ATHLETE_MERCH_GEN,
  [MENU_ITEMS.MANAGE_ATHLETE_MERCH]: MANAGE_ATHLETE_MERCH_GEN,
  [MENU_ITEMS.MANAGE_ATHLETE_PRODUCTS_GEN]: MANAGE_ATHLETE_PRODUCTS_GEN,
  [MENU_ITEMS.MANAGE_ATHLETE_PRODUCTS]: MANAGE_ATHLETE_PRODUCTS_GEN,
  [MENU_ITEMS.MANAGE_ATHLETE_EXPERIENCE_GEN]: MANAGE_ATHLETE_EXPERIENCE_GEN,
  [MENU_ITEMS.MANAGE_ATHLETE_EXPERIENCE]: MANAGE_ATHLETE_EXPERIENCE_GEN,

  [MENU_ITEMS.MANAGE_ORGANIZATION_PRODUCTS_GEN]:
    MANAGE_ORGANIZATION_PRODUCTS_GEN,
  [MENU_ITEMS.MANAGE_ORGANIZATION_PRODUCTS]: MANAGE_ORGANIZATION_PRODUCTS_GEN,
  [MENU_ITEMS.MANAGE_ORGANIZATION_EXPERIENCE_GEN]:
    MANAGE_ORGANIZATION_EXPERIENCE_GEN,
  [MENU_ITEMS.MANAGE_ORGANIZATION_EXPERIENCE]:
    MANAGE_ORGANIZATION_EXPERIENCE_GEN,
  [MENU_ITEMS.MANAGE_ORGANIZATION_MARGINS_GEN]: MANAGE_ORGANIZATION_MARGINS_GEN,
  [MENU_ITEMS.MANAGE_ORGANIZATION_MARGINS]: MANAGE_ORGANIZATION_MARGINS_GEN,

  [MENU_ITEMS.MANAGE_CONTENT_CREATOR_PRODUCTS_GEN]:
    MANAGE_CONTENT_CREATOR_PRODUCTS_GEN,
  [MENU_ITEMS.MANAGE_CONTENT_CREATOR_PRODUCTS]:
    MANAGE_CONTENT_CREATOR_PRODUCTS_GEN,
  [MENU_ITEMS.MANAGE_CONTENT_CREATOR_EXPERIENCE_GEN]:
    MANAGE_CONTENT_CREATOR_EXPERIENCE_GEN,
  [MENU_ITEMS.MANAGE_CONTENT_CREATOR_EXPERIENCE]:
    MANAGE_CONTENT_CREATOR_EXPERIENCE_GEN,
  [MENU_ITEMS.MANAGE_CONTENT_CREATOR_MARGINS_GEN]:
    MANAGE_CONTENT_CREATOR_MARGINS_GEN,
  [MENU_ITEMS.MANAGE_CONTENT_CREATOR_MARGINS]:
    MANAGE_CONTENT_CREATOR_MARGINS_GEN,

  [MENU_ITEMS.MANAGE_ATHLETE_DESIGNS_GEN]: MANAGE_ATHLETE_DESIGNS_GEN,
  [MENU_ITEMS.MANAGE_ATHLETE_DESIGNS]: MANAGE_ATHLETE_DESIGNS_GEN,
  [MENU_ITEMS.MANAGE_ATHLETE_BIO_GEN]: MANAGE_ATHLETE_BIO_GEN,
  [MENU_ITEMS.MANAGE_ATHLETE_BIO]: MANAGE_ATHLETE_BIO_GEN,
  [MENU_ITEMS.MEDIA_FEED_ATHLETE_GEN]: MEDIA_FEED_ATHLETE_GEN,
  [MENU_ITEMS.MEDIA_FEED_ATHLETE]: MEDIA_FEED_ATHLETE_GEN,
  [MENU_ITEMS.ATHLETE_STORE_SALES_GEN]: ATHLETE_STORE_SALES_GEN,
  [MENU_ITEMS.ATHLETE_STORE_SALES]: ATHLETE_STORE_SALES_GEN,

  [MENU_ITEMS.ATHLETE_SCHEDULED_EVENTS_GEN]: ATHLETE_SCHEDULED_EVENTS_GEN,
  [MENU_ITEMS.ATHLETE_SCHEDULED_EVENTS]: ATHLETE_SCHEDULED_EVENTS_GEN,

  [MENU_ITEMS.ORGANIZATION_SCHEDULED_EVENTS_GEN]:
    ORGANIZATION_SCHEDULED_EVENTS_GEN,
  [MENU_ITEMS.ORGANIZATION_SCHEDULED_EVENTS]: ORGANIZATION_SCHEDULED_EVENTS_GEN,
  [MENU_ITEMS.ATHLETE_TICKETED_EVENTS]: ATHLETE_TICKETED_EVENTS_GEN,
  [MENU_ITEMS.ORGANIZATION_TICKETED_EVENTS]: ORGANIZATION_TICKETED_EVENTS_GEN,
  [MENU_ITEMS.CONTENT_CREATOR_TICKETED_EVENTS]:
    CONTENT_CREATOR_TICKETED_EVENTS_GEN,
  [MENU_ITEMS.EVENTS_WITH_TABS]: EVENTS_WITH_TABS,
  [MENU_ITEMS.TICKETING_SETTINGS]: TICKETING_SETTINGS,
  [MENU_ITEMS.ENGAGEMENT_NOTIFICATION_SETTINGS]:
    ENGAGEMENT_NOTIFICATION_SETTINGS,

  [MENU_ITEMS.CONTENT_CREATOR_SCHEDULED_EVENTS_GEN]:
    CONTENT_CREATOR_SCHEDULED_EVENTS_GEN,
  [MENU_ITEMS.CONTENT_CREATOR_SCHEDULED_EVENTS]:
    CONTENT_CREATOR_SCHEDULED_EVENTS_GEN,

  [MENU_ITEMS.MANAGE_ORGANIZATION_STORES]: MANAGE_ORGANIZATIONS_STORES,
  [MENU_ITEMS.ORGANIZATION_DASHBOARD_GEN]: ORGANIZATION_DASHBOARD_GEN,
  [MENU_ITEMS.ORGANIZATION_DASHBOARD]: ORGANIZATION_DASHBOARD_GEN,
  [MENU_ITEMS.MANAGE_ORGANIZATION_AMA_REQUESTS]:
    MANAGE_ORGANIZATION_AMA_REQUESTS_GEN,
  [MENU_ITEMS.MANAGE_ORGANIZATION_SCHEDULED_STREAMS]:
    MANAGE_ORGANIZATION_SCHEDULED_STREAMS_GEN,
  [MENU_ITEMS.SETUP_ORGANIZATION_AMA]: SETUP_ORGANIZATION_AMA_GEN,
  [MENU_ITEMS.SETUP_ORGANIZATION_STREAM]: SETUP_ORGANIZATION_STREAM_GEN,
  [MENU_ITEMS.MANAGE_ORGANIZATION_MERCH_GEN]: MANAGE_ORGANIZATION_MERCH_GEN,
  [MENU_ITEMS.MANAGE_ORGANIZATION_MERCH]: MANAGE_ORGANIZATION_MERCH_GEN,
  [MENU_ITEMS.MANAGE_ORGANIZATION_DESIGNS_GEN]: MANAGE_ORGANIZATION_DESIGNS_GEN,
  [MENU_ITEMS.MANAGE_ORGANIZATION_DESIGNS]: MANAGE_ORGANIZATION_DESIGNS_GEN,
  [MENU_ITEMS.MANAGE_ORGANIZATION_BIO_GEN]: MANAGE_ORGANIZATION_BIO_GEN,
  [MENU_ITEMS.MANAGE_ORGANIZATION_BIO]: MANAGE_ORGANIZATION_BIO_GEN,
  [MENU_ITEMS.MEDIA_FEED_ORGANIZATION_GEN]: MEDIA_FEED_ORGANIZATION_GEN,
  [MENU_ITEMS.MEDIA_FEED_ORGANIZATION]: MEDIA_FEED_ORGANIZATION_GEN,
  [MENU_ITEMS.ORGANIZATION_STORE_SALES_GEN]: ORGANIZATION_STORE_SALES_GEN,
  [MENU_ITEMS.ORGANIZATION_STORE_SALES]: ORGANIZATION_STORE_SALES_GEN,

  [MENU_ITEMS.MANAGE_CONTENT_CREATOR_STORES]: MANAGE_CONTENT_CREATORS_STORES,
  [MENU_ITEMS.EXTERNAL_TALENTS]: EXTERNAL_TALENTS,
  [MENU_ITEMS.EXTERNAL_TALENT_IMPORT]: EXTERNAL_TALENT_IMPORT,
  [MENU_ITEMS.CONTENT_CREATOR_DASHBOARD_GEN]: CONTENT_CREATOR_DASHBOARD_GEN,
  [MENU_ITEMS.CONTENT_CREATOR_DASHBOARD]: CONTENT_CREATOR_DASHBOARD_GEN,
  [MENU_ITEMS.MANAGE_CONTENT_CREATOR_AMA_REQUESTS]:
    MANAGE_CONTENT_CREATOR_AMA_REQUESTS_GEN,
  [MENU_ITEMS.MANAGE_CONTENT_CREATOR_SCHEDULED_STREAMS]:
    MANAGE_CONTENT_CREATOR_SCHEDULED_STREAMS_GEN,
  [MENU_ITEMS.SETUP_CONTENT_CREATOR_AMA]: SETUP_CONTENT_CREATOR_AMA_GEN,
  [MENU_ITEMS.CONTENT_CREATOR_DEALS_SETUP]: CONTENT_CREATOR_DEALS_SETUP_GEN,
  [MENU_ITEMS.SETUP_CONTENT_CREATOR_STREAM]: SETUP_CONTENT_CREATOR_STREAM_GEN,
  [MENU_ITEMS.MANAGE_CONTENT_CREATOR_MERCH_GEN]:
    MANAGE_CONTENT_CREATOR_MERCH_GEN,
  [MENU_ITEMS.MANAGE_CONTENT_CREATOR_MERCH]: MANAGE_CONTENT_CREATOR_MERCH_GEN,
  [MENU_ITEMS.MANAGE_CONTENT_CREATOR_DESIGNS_GEN]:
    MANAGE_CONTENT_CREATOR_DESIGNS_GEN,
  [MENU_ITEMS.MANAGE_CONTENT_CREATOR_DESIGNS]:
    MANAGE_CONTENT_CREATOR_DESIGNS_GEN,
  [MENU_ITEMS.MANAGE_CONTENT_CREATOR_BIO_GEN]: MANAGE_CONTENT_CREATOR_BIO_GEN,
  [MENU_ITEMS.MANAGE_CONTENT_CREATOR_BIO]: MANAGE_CONTENT_CREATOR_BIO_GEN,
  [MENU_ITEMS.MEDIA_FEED_CONTENT_CREATOR_GEN]: MEDIA_FEED_CONTENT_CREATOR_GEN,
  [MENU_ITEMS.MEDIA_FEED_CONTENT_CREATOR]: MEDIA_FEED_CONTENT_CREATOR_GEN,
  [MENU_ITEMS.CONTENT_CREATOR_STORE_SALES_GEN]: CONTENT_CREATOR_STORE_SALES_GEN,
  [MENU_ITEMS.CONTENT_CREATOR_STORE_SALES]: CONTENT_CREATOR_STORE_SALES_GEN,

  [MENU_ITEMS.CUSTOMERS]: CUSTOMERS,
  [MENU_ITEMS.MANAGE_ACCOUNT]: MANAGE_ACCOUNT,
  [MENU_ITEMS.CUSTOMER_PURCHASES_GEN]: CUSTOMER_PURCHASES_GEN,
  [MENU_ITEMS.CUSTOMER_PURCHASES]: CUSTOMER_PURCHASES_GEN,
  [MENU_ITEMS.CUSTOMER_SETTINGS_GEN]: CUSTOMER_SETTINGS_GEN,
  [MENU_ITEMS.CUSTOMER_SETTINGS]: CUSTOMER_SETTINGS_GEN,
  [MENU_ITEMS.CUSTOMER_ADDRESSES_GEN]: CUSTOMER_ADDRESSES_GEN,
  [MENU_ITEMS.CUSTOMER_ADDRESSES]: CUSTOMER_ADDRESSES_GEN,
  [MENU_ITEMS.CUSTOMER_PAYMENT_GEN]: CUSTOMER_PAYMENT_GEN,
  [MENU_ITEMS.CUSTOMER_PAYMENT]: CUSTOMER_PAYMENT_GEN,

  [MENU_ITEMS.ALL_PRODUCT_MEMORABILIA]: ALL_PRODUCT_MEMORABILIA,

  [MENU_ITEMS.ALL_AMA_REQUESTS]: ALL_AMA_REQUESTS,

  [MENU_ITEMS.STREAMS_CALENDAR]: STREAMS_CALENDAR,
  [MENU_ITEMS.ALL_STREAMS_TABLE]: ALL_STREAMS_TABLE,
  [MENU_ITEMS.MANAGE_WATCH_STREAM_MODERATORS_GEN]:
    MANAGE_WATCH_STREAM_MODERATORS_GEN,
  [MENU_ITEMS.WATCH_STREAM]: WATCH_STREAM_GEN,

  [MENU_ITEMS.PROMO_CODES]: PROMO_CODES,

  [MENU_ITEMS.REDIRECTS]: REDIRECTS,

  [MENU_ITEMS.GENERAL_SALES]: GENERAL_SALES,
  [MENU_ITEMS.EXPERIENCE_SALES]: EXPERIENCE_SALES,
  [MENU_ITEMS.MANAGE_MESSAGES]: MANAGE_MESSAGES,
  [MENU_ITEMS.CAMPAIGNS]: CAMPAIGNS,
  [MENU_ITEMS.BRANDS]: BRANDS,
  [MENU_ITEMS.BRAND_DETAILS]: BRAND_DETAILS,
  [MENU_ITEMS.BILLING]: BILLING,
  [MENU_ITEMS.CB_SETTINGS]: CB_SETTINGS,
  [MENU_ITEMS.CB_TEAM_OWNERSHIP]: CB_TEAM_OWNERSHIP,
  [MENU_ITEMS.CB_PROMO_CODES]: CB_PROMO_CODES,
  [MENU_ITEMS.CB_DIGITAL_AGREEMENT_SETTINGS]: CB_DIGITAL_AGREEMENT_SETTINGS,
  [MENU_ITEMS.CB_SIGN_UP_SETTINGS]: CB_SIGN_UP_SETTINGS,
  [MENU_ITEMS.BRAND_PREFERENCES]: BRAND_PREFERENCES,
  [MENU_ITEMS.CREDIT_USAGE_REPORT]: CREDIT_USAGE_REPORT,
  [MENU_ITEMS.CREDIT_USAGE_DETAILS]: CREDIT_USAGE_DETAILS,
  [MENU_ITEMS.INFLUENCER_CATEGORIES]: INFLUENCER_CATEGORIES,
  [MENU_ITEMS.PRODUCT_CATEGORIES]: PRODUCT_CATEGORIES,
  [MENU_ITEMS.RESTRICTED_CATEGORIES]: RESTRICTED_CATEGORIES,
  [MENU_ITEMS.CAMPAIGN_DETAILS]: CAMPAIGN_DETAILS,

  [MENU_ITEMS.ADMINS]: ADMINS,

  [MENU_ITEMS.MERCH_SALES_REPORT]: MERCH_SALES_REPORT,
  [MENU_ITEMS.AMA_SALES_REPORT]: AMA_SALES_REPORT,
  [MENU_ITEMS.STREAM_SALES_REPORT]: STREAM_SALES_REPORT,
  [MENU_ITEMS.AFFILIATE_COMMISSIONS_REPORT]: AFFILIATE_COMMISSIONS_REPORT,
  [MENU_ITEMS.AFFILIATE_STREAMS]: AFFILIATE_STREAMS,
  [MENU_ITEMS.MANUAL_MERCH_MERGE]: MANUAL_MERCH_MERGE,

  [MENU_ITEMS.INTERVIEWS]: INTERVIEWS,
  [MENU_ITEMS.INTERVIEW_CHATS]: INTERVIEW_CHATS,
  [MENU_ITEMS.INTERVIEWERS]: INTERVIEWERS,
  [MENU_ITEMS.INTERVIEW_SETTINGS]: INTERVIEW_SETTINGS,
  [MENU_ITEMS.INTERVIEW_NOW_TRANSITIONS]: INTERVIEW_NOW_TRANSITIONS,
  [MENU_ITEMS.INTERVIEW_NOW_NOTIFICATIONS]: INTERVIEW_NOW_NOTIFICATIONS,
  [MENU_ITEMS.CHANNEL_MONETIZATION]: CHANNEL_MONETIZATION,
  [MENU_ITEMS.CHANNEL_MONETIZATION_APPLICATIONS]:
    CHANNEL_MONETIZATION_APPLICATIONS,
  [MENU_ITEMS.CHANNEL_MONETIZATION_LEADERBOARD]:
    CHANNEL_MONETIZATION_LEADERBOARD,
  [MENU_ITEMS.FEATURE_LIMITS]: FEATURE_LIMITS,
  [MENU_ITEMS.ACTIVE_FEATURE_LIMITS]: ACTIVE_FEATURE_LIMITS,
  [MENU_ITEMS.AUDIT_LOGS]: AUDIT_LOGS,

  [MENU_ITEMS.AI_CLIPS]: AI_CLIPS,
  [MENU_ITEMS.AI_CLIP_DETAIL_GEN]: AI_CLIP_DETAIL_GEN,
  [MENU_ITEMS.AI_CLIP_DETAIL]: AI_CLIP_DETAIL,
  [MENU_ITEMS.AI_CLIPPER_METRICS]: AI_CLIPPER_METRICS,
  [MENU_ITEMS.AI_CLIPPER_SETTINGS]: AI_CLIPPER_SETTINGS,
  [MENU_ITEMS.AI_POST_CLIPS]: AI_POST_CLIPS,
  [MENU_ITEMS.AI_POST_CLIP_DETAIL_GEN]: AI_POST_CLIP_DETAIL_GEN,
  [MENU_ITEMS.AI_POST_CLIP_DETAIL]: AI_POST_CLIP_DETAIL,
  [MENU_ITEMS.AI_PPV_CLIPS]: AI_PPV_CLIPS,
  [MENU_ITEMS.PPV_CLIP_ANALYTICS]: PPV_CLIP_ANALYTICS,
  [MENU_ITEMS.PPV_AUTO_FREE_SETTINGS]: PPV_AUTO_FREE_SETTINGS,
  [MENU_ITEMS.AI_PPV_CLIP_DETAIL_GEN]: AI_PPV_CLIP_DETAIL_GEN,
  [MENU_ITEMS.AI_PPV_CLIP_DETAIL]: AI_PPV_CLIP_DETAIL,
  [MENU_ITEMS.MY_AVAILABILITY]: MY_AVAILABILITY,

  [MENU_ITEMS.ARTICLES]: ARTICLES,
  [MENU_ITEMS.CREATE_PROFILE]: CREATE_PROFILE,
  [MENU_ITEMS.SOCIAL_MEDIA_INTEGRATION_SETTINGS]:
    SOCIAL_MEDIA_INTEGRATION_SETTINGS,
};

const LINKS_MENU: Record<string, string> = {
  [HOME_PAGE_MANAGEMENT]: MENU_ITEMS.HOME_PAGE_MANAGEMENT,
  [FEATURED_STREAMS]: MENU_ITEMS.FEATURED_STREAMS,
  [DASHBOARD]: MENU_ITEMS.DASHBOARD,
  [TAGS]: MENU_ITEMS.TAGS,

  // [MANAGE_MERCH_GEN]: MENU_ITEMS.MANAGE_MERCH_GEN,
  // [MANAGE_MERCH]: MENU_ITEMS.MANAGE_MERCH,
  [MANAGE_MERCH_TSHIRT]: MENU_ITEMS.MANAGE_MERCH_TSHIRT,
  [MANAGE_MERCH_HOODIE]: MENU_ITEMS.MANAGE_MERCH_HOODIE,
  [MANAGE_MERCH_HAT]: MENU_ITEMS.MANAGE_MERCH_HAT,

  [MANAGE_ATHLETES_STORES_WITH_PAGINATION]:
    MENU_ITEMS.MANAGE_ATHLETES_STORES_WITH_PAGINATION,
  [ATHLETE_DASHBOARD_GEN]: MENU_ITEMS.ATHLETE_DASHBOARD_GEN,
  [ATHLETE_DASHBOARD]: MENU_ITEMS.ATHLETE_DASHBOARD,
  [MANAGE_ATHLETE_MARGINS_GEN]: MENU_ITEMS.MANAGE_ATHLETE_MARGINS_GEN,
  [MANAGE_ATHLETE_MARGINS]: MENU_ITEMS.MANAGE_ATHLETE_MARGINS,
  [MANAGE_ATHLETE_AMA_REQUESTS]: MENU_ITEMS.MANAGE_ATHLETE_AMA_REQUESTS,
  [MANAGE_ATHLETE_SCHEDULED_STREAMS]:
    MENU_ITEMS.MANAGE_ATHLETE_SCHEDULED_STREAMS,
  [SETUP_ATHLETE_STREAM]: MENU_ITEMS.SETUP_ATHLETE_STREAM,
  [SETUP_ATHLETE_AMA]: MENU_ITEMS.SETUP_ATHLETE_AMA,
  [ATHLETE_DEALS_SETUP]: MENU_ITEMS.ATHLETE_DEALS_SETUP,
  [MANAGE_ATHLETE_MERCH_GEN]: MENU_ITEMS.MANAGE_ATHLETE_MERCH_GEN,
  [MANAGE_ATHLETE_MERCH]: MENU_ITEMS.MANAGE_ATHLETE_MERCH,
  [MANAGE_ATHLETE_PRODUCTS_GEN]: MENU_ITEMS.MANAGE_ATHLETE_PRODUCTS_GEN,
  [MANAGE_ATHLETE_PRODUCTS]: MENU_ITEMS.MANAGE_ATHLETE_PRODUCTS,
  [MANAGE_ATHLETE_EXPERIENCE_GEN]: MENU_ITEMS.MANAGE_ATHLETE_EXPERIENCE_GEN,
  [MANAGE_ATHLETE_EXPERIENCE]: MENU_ITEMS.MANAGE_ATHLETE_EXPERIENCE,

  [MANAGE_ORGANIZATION_PRODUCTS_GEN]:
    MENU_ITEMS.MANAGE_ORGANIZATION_PRODUCTS_GEN,
  [MANAGE_ORGANIZATION_PRODUCTS]: MENU_ITEMS.MANAGE_ORGANIZATION_PRODUCTS,
  [MANAGE_ORGANIZATION_EXPERIENCE_GEN]:
    MENU_ITEMS.MANAGE_ORGANIZATION_EXPERIENCE_GEN,
  [MANAGE_ORGANIZATION_EXPERIENCE]: MENU_ITEMS.MANAGE_ORGANIZATION_EXPERIENCE,

  [MANAGE_CONTENT_CREATOR_PRODUCTS_GEN]:
    MENU_ITEMS.MANAGE_CONTENT_CREATOR_PRODUCTS_GEN,
  [MANAGE_CONTENT_CREATOR_PRODUCTS]: MENU_ITEMS.MANAGE_CONTENT_CREATOR_PRODUCTS,
  [MANAGE_CONTENT_CREATOR_EXPERIENCE_GEN]:
    MENU_ITEMS.MANAGE_CONTENT_CREATOR_EXPERIENCE_GEN,
  [MANAGE_CONTENT_CREATOR_EXPERIENCE]:
    MENU_ITEMS.MANAGE_CONTENT_CREATOR_EXPERIENCE,

  [MANAGE_ATHLETE_DESIGNS_GEN]: MENU_ITEMS.MANAGE_ATHLETE_DESIGNS_GEN,
  [MANAGE_ATHLETE_DESIGNS]: MENU_ITEMS.MANAGE_ATHLETE_DESIGNS,
  [MANAGE_ATHLETE_BIO_GEN]: MENU_ITEMS.MANAGE_ATHLETE_BIO_GEN,
  [MANAGE_ATHLETE_BIO]: MENU_ITEMS.MANAGE_ATHLETE_BIO,
  [MEDIA_FEED_ATHLETE_GEN]: MENU_ITEMS.MEDIA_FEED_ATHLETE_GEN,
  [MEDIA_FEED_ATHLETE]: MENU_ITEMS.MEDIA_FEED_ATHLETE,
  [ATHLETE_STORE_SALES_GEN]: MENU_ITEMS.ATHLETE_STORE_SALES_GEN,
  [ATHLETE_STORE_SALES]: MENU_ITEMS.ATHLETE_STORE_SALES,

  [ATHLETE_SCHEDULED_EVENTS_GEN]: MENU_ITEMS.ATHLETE_SCHEDULED_EVENTS_GEN,
  [ATHLETE_SCHEDULED_EVENTS]: MENU_ITEMS.ATHLETE_SCHEDULED_EVENTS,

  [ORGANIZATION_SCHEDULED_EVENTS_GEN]:
    MENU_ITEMS.ORGANIZATION_SCHEDULED_EVENTS_GEN,
  [ORGANIZATION_SCHEDULED_EVENTS]: MENU_ITEMS.ORGANIZATION_SCHEDULED_EVENTS,
  [ATHLETE_TICKETED_EVENTS]: MENU_ITEMS.ATHLETE_TICKETED_EVENTS,
  [ORGANIZATION_TICKETED_EVENTS]: MENU_ITEMS.ORGANIZATION_TICKETED_EVENTS,
  [CONTENT_CREATOR_TICKETED_EVENTS]: MENU_ITEMS.CONTENT_CREATOR_TICKETED_EVENTS,
  [EVENTS_WITH_TABS]: MENU_ITEMS.EVENTS_WITH_TABS,
  [TICKETING_SETTINGS]: MENU_ITEMS.TICKETING_SETTINGS,
  [ENGAGEMENT_NOTIFICATION_SETTINGS]:
    MENU_ITEMS.ENGAGEMENT_NOTIFICATION_SETTINGS,
  [CREATE_TICKET_EVENT]: MENU_ITEMS.EVENTS_WITH_TABS,
  [EDIT_TICKET_EVENT]: MENU_ITEMS.EVENTS_WITH_TABS,
  [TICKET_EVENT_DETAILS]: MENU_ITEMS.EVENTS_WITH_TABS,

  [CONTENT_CREATOR_SCHEDULED_EVENTS_GEN]:
    MENU_ITEMS.CONTENT_CREATOR_SCHEDULED_EVENTS_GEN,
  [CONTENT_CREATOR_SCHEDULED_EVENTS]:
    MENU_ITEMS.CONTENT_CREATOR_SCHEDULED_EVENTS,

  [MANAGE_ORGANIZATIONS_STORES_WITH_PAGINATION]:
    MENU_ITEMS.MANAGE_ORGANIZATIONS_STORES_WITH_PAGINATION,
  [ORGANIZATION_DASHBOARD_GEN]: MENU_ITEMS.ORGANIZATION_DASHBOARD_GEN,
  [ORGANIZATION_DASHBOARD]: MENU_ITEMS.ORGANIZATION_DASHBOARD,
  [MANAGE_ORGANIZATION_MARGINS_GEN]: MENU_ITEMS.MANAGE_ORGANIZATION_MARGINS_GEN,
  [MANAGE_ORGANIZATION_MARGINS]: MENU_ITEMS.MANAGE_ORGANIZATION_MARGINS,
  [MANAGE_ORGANIZATION_AMA_REQUESTS]:
    MENU_ITEMS.MANAGE_ORGANIZATION_AMA_REQUESTS,
  [MANAGE_ORGANIZATION_SCHEDULED_STREAMS]:
    MENU_ITEMS.MANAGE_ORGANIZATION_SCHEDULED_STREAMS,
  [SETUP_ORGANIZATION_STREAM]: MENU_ITEMS.SETUP_ORGANIZATION_STREAM,
  [SETUP_ORGANIZATION_AMA]: MENU_ITEMS.SETUP_ORGANIZATION_AMA,
  [MANAGE_ORGANIZATION_MERCH_GEN]: MENU_ITEMS.MANAGE_ORGANIZATION_MERCH_GEN,
  [MANAGE_ORGANIZATION_MERCH]: MENU_ITEMS.MANAGE_ORGANIZATION_MERCH,
  [MANAGE_ORGANIZATION_DESIGNS_GEN]: MENU_ITEMS.MANAGE_ORGANIZATION_DESIGNS_GEN,
  [MANAGE_ORGANIZATION_DESIGNS]: MENU_ITEMS.MANAGE_ORGANIZATION_DESIGNS,
  [MANAGE_ORGANIZATION_BIO_GEN]: MENU_ITEMS.MANAGE_ORGANIZATION_BIO_GEN,
  [MANAGE_ORGANIZATION_BIO]: MENU_ITEMS.MANAGE_ORGANIZATION_BIO,
  [MEDIA_FEED_ORGANIZATION_GEN]: MENU_ITEMS.MEDIA_FEED_ORGANIZATION_GEN,
  [MEDIA_FEED_ORGANIZATION]: MENU_ITEMS.MEDIA_FEED_ORGANIZATION,
  [ORGANIZATION_STORE_SALES_GEN]: MENU_ITEMS.ORGANIZATION_STORE_SALES_GEN,
  [ORGANIZATION_STORE_SALES]: MENU_ITEMS.ORGANIZATION_STORE_SALES,

  [MANAGE_CONTENT_CREATORS_STORES_WITH_PAGINATION]:
    MENU_ITEMS.MANAGE_CONTENT_CREATORS_STORES_WITH_PAGINATION,
  [EXTERNAL_TALENTS]: MENU_ITEMS.EXTERNAL_TALENTS,
  [EXTERNAL_TALENT_IMPORT]: MENU_ITEMS.EXTERNAL_TALENT_IMPORT,
  [CONTENT_CREATOR_DASHBOARD_GEN]: MENU_ITEMS.CONTENT_CREATOR_DASHBOARD_GEN,
  [CONTENT_CREATOR_DASHBOARD]: MENU_ITEMS.CONTENT_CREATOR_DASHBOARD,
  [MANAGE_CONTENT_CREATOR_MARGINS_GEN]:
    MENU_ITEMS.MANAGE_CONTENT_CREATOR_MARGINS_GEN,
  [MANAGE_CONTENT_CREATOR_MARGINS]: MENU_ITEMS.MANAGE_CONTENT_CREATOR_MARGINS,
  [MANAGE_CONTENT_CREATOR_AMA_REQUESTS]:
    MENU_ITEMS.MANAGE_CONTENT_CREATOR_AMA_REQUESTS,
  [MANAGE_CONTENT_CREATOR_SCHEDULED_STREAMS]:
    MENU_ITEMS.MANAGE_CONTENT_CREATOR_SCHEDULED_STREAMS,
  [SETUP_CONTENT_CREATOR_STREAM]: MENU_ITEMS.SETUP_CONTENT_CREATOR_STREAM,
  [SETUP_CONTENT_CREATOR_AMA]: MENU_ITEMS.SETUP_CONTENT_CREATOR_AMA,
  [CONTENT_CREATOR_DEALS_SETUP]: MENU_ITEMS.CONTENT_CREATOR_DEALS_SETUP,
  [MANAGE_CONTENT_CREATOR_MERCH_GEN]:
    MENU_ITEMS.MANAGE_CONTENT_CREATOR_MERCH_GEN,
  [MANAGE_CONTENT_CREATOR_MERCH]: MENU_ITEMS.MANAGE_CONTENT_CREATOR_MERCH,
  [MANAGE_CONTENT_CREATOR_DESIGNS_GEN]:
    MENU_ITEMS.MANAGE_CONTENT_CREATOR_DESIGNS_GEN,
  [MANAGE_CONTENT_CREATOR_DESIGNS]: MENU_ITEMS.MANAGE_CONTENT_CREATOR_DESIGNS,
  [MANAGE_CONTENT_CREATOR_BIO_GEN]: MENU_ITEMS.MANAGE_CONTENT_CREATOR_BIO_GEN,
  [MANAGE_CONTENT_CREATOR_BIO]: MENU_ITEMS.MANAGE_CONTENT_CREATOR_BIO,
  [MEDIA_FEED_CONTENT_CREATOR_GEN]: MENU_ITEMS.MEDIA_FEED_CONTENT_CREATOR_GEN,
  [MEDIA_FEED_CONTENT_CREATOR]: MENU_ITEMS.MEDIA_FEED_CONTENT_CREATOR,
  [CONTENT_CREATOR_STORE_SALES_GEN]: MENU_ITEMS.CONTENT_CREATOR_STORE_SALES_GEN,
  [CONTENT_CREATOR_STORE_SALES]: MENU_ITEMS.CONTENT_CREATOR_STORE_SALES,

  [CUSTOMERS_WITH_PAGINATION]: MENU_ITEMS.CUSTOMERS_WITH_PAGINATION,
  [MANAGE_ACCOUNT]: MENU_ITEMS.MANAGE_ACCOUNT,
  [CUSTOMER_PURCHASES_GEN]: MENU_ITEMS.CUSTOMER_PURCHASES_GEN,
  [CUSTOMER_PURCHASES]: MENU_ITEMS.CUSTOMER_PURCHASES,
  [CUSTOMER_SETTINGS_GEN]: MENU_ITEMS.CUSTOMER_SETTINGS_GEN,
  [CUSTOMER_SETTINGS]: MENU_ITEMS.CUSTOMER_SETTINGS,
  [CUSTOMER_ADDRESSES_GEN]: MENU_ITEMS.CUSTOMER_ADDRESSES_GEN,
  [CUSTOMER_ADDRESSES]: MENU_ITEMS.CUSTOMER_ADDRESSES,
  [CUSTOMER_PAYMENT_GEN]: MENU_ITEMS.CUSTOMER_PAYMENT_GEN,
  [CUSTOMER_PAYMENT]: MENU_ITEMS.CUSTOMER_PAYMENT,

  [ALL_PRODUCT_MEMORABILIA]: MENU_ITEMS.ALL_PRODUCT_MEMORABILIA,

  [ALL_AMA_REQUESTS]: MENU_ITEMS.ALL_AMA_REQUESTS,

  [STREAMS_CALENDAR]: MENU_ITEMS.STREAMS_CALENDAR,
  [ALL_STREAMS_TABLE]: MENU_ITEMS.ALL_STREAMS_TABLE,
  [MANAGE_WATCH_STREAM_MODERATORS_GEN]:
    MENU_ITEMS.MANAGE_WATCH_STREAM_MODERATORS_GEN,
  [WATCH_STREAM]: MENU_ITEMS.WATCH_STREAM,

  [PROMO_CODES]: MENU_ITEMS.PROMO_CODES,
  [BULK_UPLOAD]: MENU_ITEMS.BULK_UPLOAD,
  [DESIGN_REQUESTS]: MENU_ITEMS.DESIGN_REQUESTS,
  [DESIGNERS]: MENU_ITEMS.DESIGNERS,
  [MY_DESIGN_REQUESTS]: MENU_ITEMS.MY_DESIGN_REQUESTS,

  [EDITING_REQUESTS]: MENU_ITEMS.EDITING_REQUESTS,
  [VIDEO_EDITORS]: MENU_ITEMS.VIDEO_EDITORS,
  [VIDEO_EDIT_REQUEST_SETTINGS]: MENU_ITEMS.VIDEO_EDIT_REQUEST_SETTINGS,

  [LIST_OF_ASSIGNED_STREAMS]: MENU_ITEMS.LIST_OF_ASSIGNED_STREAMS,
  [GENERAL_SALES]: MENU_ITEMS.GENERAL_SALES,
  [EXPERIENCE_SALES]: MENU_ITEMS.EXPERIENCE_SALES,
  [MANUAL_MERCH_MERGE]: MENU_ITEMS.MANUAL_MERCH_MERGE,
  [MANAGE_MESSAGES]: MENU_ITEMS.MANAGE_MESSAGES,
  [MANAGE_MESSAGES_WITH_PAGINATION]: MENU_ITEMS.MANAGE_MESSAGES_WITH_PAGINATION,
  [CAMPAIGNS]: MENU_ITEMS.CAMPAIGNS,
  [BRANDS]: MENU_ITEMS.BRANDS,
  [BRANDS_WITH_PAGINATION]: MENU_ITEMS.BRANDS,
  [BRAND_DETAILS]: MENU_ITEMS.BRAND_DETAILS,
  [BILLING]: MENU_ITEMS.BILLING,
  [CB_SETTINGS]: MENU_ITEMS.CB_SETTINGS,
  [CB_TEAM_OWNERSHIP]: MENU_ITEMS.CB_TEAM_OWNERSHIP,
  [CB_PROMO_CODES]: MENU_ITEMS.CB_PROMO_CODES,
  [CB_DIGITAL_AGREEMENT_SETTINGS]: MENU_ITEMS.CB_DIGITAL_AGREEMENT_SETTINGS,
  [CB_SIGN_UP_SETTINGS]: MENU_ITEMS.CB_SIGN_UP_SETTINGS,
  [BRAND_PREFERENCES]: MENU_ITEMS.BRAND_PREFERENCES,
  [CREDIT_USAGE_REPORT]: MENU_ITEMS.CREDIT_USAGE_REPORT,
  [CREDIT_USAGE_REPORT_WITH_PAGINATION]: MENU_ITEMS.CREDIT_USAGE_REPORT,
  [CREDIT_USAGE_DETAILS]: MENU_ITEMS.CREDIT_USAGE_DETAILS,
  [CREDIT_USAGE_DETAILS_GEN]: MENU_ITEMS.CREDIT_USAGE_DETAILS,
  [INFLUENCER_CATEGORIES]: MENU_ITEMS.INFLUENCER_CATEGORIES,
  [PRODUCT_CATEGORIES]: MENU_ITEMS.PRODUCT_CATEGORIES,
  [RESTRICTED_CATEGORIES]: MENU_ITEMS.RESTRICTED_CATEGORIES,
  [ADMINS]: MENU_ITEMS.ADMINS,
  [CREATE_PROFILE]: MENU_ITEMS.CREATE_PROFILE,
  [MY_EDITING_REQUESTS]: MENU_ITEMS.MY_EDITING_REQUESTS,
  [VIDEO_EDITOR_PROFILE]: MENU_ITEMS.VIDEO_EDITOR_PROFILE,

  [REDIRECTS]: MENU_ITEMS.REDIRECTS,

  [MERCH_SALES_REPORT]: MENU_ITEMS.MERCH_SALES_REPORT,
  [AMA_SALES_REPORT]: MENU_ITEMS.AMA_SALES_REPORT,
  [STREAM_SALES_REPORT]: MENU_ITEMS.STREAM_SALES_REPORT,
  [AFFILIATE_COMMISSIONS_REPORT]: MENU_ITEMS.AFFILIATE_COMMISSIONS_REPORT,
  [AFFILIATE_STREAMS]: MENU_ITEMS.AFFILIATE_STREAMS,

  [INTERVIEWS]: MENU_ITEMS.INTERVIEWS,
  [INTERVIEW_CHATS]: MENU_ITEMS.INTERVIEW_CHATS,
  [INTERVIEWERS]: MENU_ITEMS.INTERVIEWERS,
  [MY_AVAILABILITY]: MENU_ITEMS.MY_AVAILABILITY,
  [MY_INTERVIEWS]: MENU_ITEMS.MY_INTERVIEWS,
  [MY_SCHEDULED_EVENTS]: MENU_ITEMS.MY_SCHEDULED_EVENTS,
  [INTERVIEW_SETTINGS]: MENU_ITEMS.INTERVIEW_SETTINGS,
  [INTERVIEW_NOW_TRANSITIONS]: MENU_ITEMS.INTERVIEW_NOW_TRANSITIONS,
  [INTERVIEW_NOW_NOTIFICATIONS]: MENU_ITEMS.INTERVIEW_NOW_NOTIFICATIONS,
  [CHANNEL_MONETIZATION]: MENU_ITEMS.CHANNEL_MONETIZATION,
  [CHANNEL_MONETIZATION_APPLICATIONS]:
    MENU_ITEMS.CHANNEL_MONETIZATION_APPLICATIONS,
  [CHANNEL_MONETIZATION_LEADERBOARD]:
    MENU_ITEMS.CHANNEL_MONETIZATION_LEADERBOARD,
  [FEATURE_LIMITS]: MENU_ITEMS.FEATURE_LIMITS,
  [ACTIVE_FEATURE_LIMITS]: MENU_ITEMS.ACTIVE_FEATURE_LIMITS,
  [AUDIT_LOGS]: MENU_ITEMS.AUDIT_LOGS,

  [AI_CLIPS]: MENU_ITEMS.AI_CLIPS,
  [AI_CLIP_DETAIL_GEN]: MENU_ITEMS.AI_CLIPS,
  [AI_CLIP_DETAIL]: MENU_ITEMS.AI_CLIPS,
  [AI_CLIPPER_METRICS]: MENU_ITEMS.AI_CLIPPER_METRICS,
  [AI_CLIPPER_SETTINGS]: MENU_ITEMS.AI_CLIPPER_SETTINGS,
  [AI_POST_CLIPS]: MENU_ITEMS.AI_POST_CLIPS,
  [AI_POST_CLIP_DETAIL_GEN]: MENU_ITEMS.AI_POST_CLIPS,
  [AI_POST_CLIP_DETAIL]: MENU_ITEMS.AI_POST_CLIPS,
  [AI_PPV_CLIPS]: MENU_ITEMS.AI_PPV_CLIPS,
  [PPV_CLIP_ANALYTICS]: MENU_ITEMS.PPV_CLIP_ANALYTICS,
  [PPV_AUTO_FREE_SETTINGS]: MENU_ITEMS.PPV_AUTO_FREE_SETTINGS,
  [AI_PPV_CLIP_DETAIL_GEN]: MENU_ITEMS.AI_PPV_CLIPS,
  [AI_PPV_CLIP_DETAIL]: MENU_ITEMS.AI_PPV_CLIPS,

  [ARTICLES]: MENU_ITEMS.ARTICLES,
  [ARTICLES_WITH_PAGINATION]: MENU_ITEMS.ARTICLES_WITH_PAGINATION,
  [CAMPAIGN_DETAILS]: MENU_ITEMS.CAMPAIGN_DETAILS,
  [SOCIAL_MEDIA_INTEGRATION_SETTINGS]:
    MENU_ITEMS.SOCIAL_MEDIA_INTEGRATION_SETTINGS,
};

// const CAMPAIGN_DETAILS_MENU: Record<string, string> = {};

const PAGE_TITLES: Record<string, string> = {
  [HOME_PAGE_MANAGEMENT]: 'Home Page Management',
  [FEATURED_STREAMS]: 'Featured Streams Management',
  [DASHBOARD]: 'Dashboard',
  [TAGS]: 'Manage Tags',

  // [MANAGE_MERCH_GEN]: 'Manage Merch',
  [MANAGE_MERCH_TSHIRT_GEN]: 'Manage T-Shirt',
  [MANAGE_MERCH_HOODIE_GEN]: 'Manage Hoodie',
  [MANAGE_MERCH_HAT_GEN]: 'Manage Hat',
  [MANAGE_MERCH_JOGGERS_GEN]: 'Manage Joggers',
  [MANAGE_MERCH_RASH_GUARD_GEN]: 'Manage Rash-Guard',

  [MANAGE_ATHLETES_STORES]: 'Manage Athletes',
  [MANAGE_ATHLETES_STORES_WITH_PAGINATION]: 'Manage Athletes',
  [ATHLETE_DASHBOARD_GEN]: 'Dashboard',
  [MANAGE_ATHLETE_MARGINS_GEN]: 'Manage Margins',
  [MANAGE_ORGANIZATION_MARGINS_GEN]: 'Manage Margins',
  [MANAGE_CONTENT_CREATOR_MARGINS_GEN]: 'Manage Margins',
  [MANAGE_ATHLETE_AMA_REQUESTS_GEN]: 'Manage AMA requests',
  [MANAGE_ATHLETE_SCHEDULED_STREAMS_GEN]: 'Manage Scheduled Streams',
  [SETUP_ATHLETE_AMA_GEN]: 'Setup AMA',
  [ATHLETE_DEALS_SETUP_GEN]: 'Brand Deals Setup',
  [SETUP_ATHLETE_STREAM_GEN]: 'Setup Stream',
  [MANAGE_ATHLETE_MERCH_GEN]: 'Manage Merch',
  [MANAGE_ATHLETE_PRODUCTS_GEN]: 'Manage Memorabilia',
  [MANAGE_ATHLETE_EXPERIENCE_GEN]: 'Manage Experience',

  [MANAGE_ORGANIZATION_PRODUCTS_GEN]: 'Manage Memorabilia',
  [MANAGE_ORGANIZATION_EXPERIENCE_GEN]: 'Manage Experience',
  [MANAGE_CONTENT_CREATOR_PRODUCTS_GEN]: 'Manage Memorabilia',
  [MANAGE_CONTENT_CREATOR_EXPERIENCE_GEN]: 'Manage Experience',
  [MANAGE_ATHLETE_DESIGNS_GEN]: 'Manage Designs',
  [MANAGE_ATHLETE_BIO_GEN]: 'Manage bio',
  [MEDIA_FEED_ATHLETE_GEN]: 'Media Feed',
  [MEDIA_FEED_ATHLETE]: 'Media Feed',
  [ATHLETE_STORE_SALES_GEN]: 'Sales',
  [ATHLETE_SCHEDULED_EVENTS_GEN]: 'Scheduled Events',
  [ORGANIZATION_SCHEDULED_EVENTS_GEN]: 'Scheduled Events',
  [ATHLETE_TICKETED_EVENTS_GEN]: 'Ticketed Events',
  [ORGANIZATION_TICKETED_EVENTS_GEN]: 'Ticketed Events',
  [CONTENT_CREATOR_TICKETED_EVENTS_GEN]: 'Ticketed Events',
  [EVENTS_WITH_TABS]: 'Events',
  [TICKETING_SETTINGS]: 'Ticketing Settings',
  [ENGAGEMENT_NOTIFICATION_SETTINGS]: 'Like & Comment Notifications',
  [CREATE_TICKET_EVENT]: 'Create Event',
  [EDIT_TICKET_EVENT]: 'Edit Event',
  [TICKET_EVENT_DETAILS]: 'Event',
  [CONTENT_CREATOR_SCHEDULED_EVENTS_GEN]: 'Scheduled Events',

  [MEDIA_FEED_ORGANIZATION_GEN]: 'Media Feed',
  [MEDIA_FEED_ORGANIZATION]: 'Media Feed',
  [MEDIA_FEED_CONTENT_CREATOR_GEN]: 'Media Feed',
  [MEDIA_FEED_CONTENT_CREATOR]: 'Media Feed',

  [MANAGE_ORGANIZATIONS_STORES]: 'Manage Organizations',
  [MANAGE_ORGANIZATIONS_STORES_WITH_PAGINATION]: 'Manage Organizations',
  [ORGANIZATION_DASHBOARD_GEN]: 'Dashboard',
  [MANAGE_ORGANIZATION_AMA_REQUESTS_GEN]: 'Manage AMA requests',
  [MANAGE_ORGANIZATION_SCHEDULED_STREAMS_GEN]: 'Manage Scheduled Streams',
  [SETUP_ORGANIZATION_AMA_GEN]: 'Setup AMA',
  [SETUP_ORGANIZATION_STREAM_GEN]: 'Setup Stream',
  [MANAGE_ORGANIZATION_MERCH_GEN]: 'Manage Merch',
  [MANAGE_ORGANIZATION_DESIGNS_GEN]: 'Manage Designs',
  [MANAGE_ORGANIZATION_BIO_GEN]: 'Manage bio',
  [ORGANIZATION_STORE_SALES_GEN]: 'Sales',

  [MANAGE_CONTENT_CREATORS_STORES]: 'Manage Content Creators',
  [MANAGE_CONTENT_CREATORS_STORES_WITH_PAGINATION]: 'Manage Content Creators',
  [EXTERNAL_TALENTS]: 'External Talents',
  [EXTERNAL_TALENT_IMPORT]: 'Import External Talents',
  [CONTENT_CREATOR_DASHBOARD_GEN]: 'Dashboard',
  [MANAGE_CONTENT_CREATOR_AMA_REQUESTS_GEN]: 'Manage AMA requests',
  [MANAGE_CONTENT_CREATOR_SCHEDULED_STREAMS_GEN]: 'Manage Scheduled Streams',
  [SETUP_CONTENT_CREATOR_AMA_GEN]: 'Setup AMA',
  [CONTENT_CREATOR_DEALS_SETUP_GEN]: 'Brand Deals Setup',
  [SETUP_CONTENT_CREATOR_STREAM_GEN]: 'Setup Stream',
  [MANAGE_CONTENT_CREATOR_MERCH_GEN]: 'Manage Merch',
  [MANAGE_CONTENT_CREATOR_DESIGNS_GEN]: 'Manage Designs',
  [MANAGE_CONTENT_CREATOR_BIO_GEN]: 'Manage bio',
  [CONTENT_CREATOR_STORE_SALES_GEN]: 'Sales',

  [CUSTOMERS_WITH_PAGINATION]: 'Customers',
  [CUSTOMERS]: 'Customers',

  [CUSTOMER_PURCHASES_GEN]: 'Purchases',
  [CUSTOMER_SETTINGS_GEN]: 'Settings',
  [CUSTOMER_ADDRESSES_GEN]: 'Addresses',
  [CUSTOMER_PAYMENT_GEN]: 'Payment',

  [ALL_PRODUCT_MEMORABILIA]: 'Memorabilia',

  [ALL_AMA_REQUESTS]: 'AMA Requests',

  [STREAMS_CALENDAR]: 'Streams Calendar',
  [ALL_STREAMS_TABLE]: 'All Streams',
  [WATCH_STREAM_GEN]: 'Watch Stream',
  [MANAGE_WATCH_STREAM_MODERATORS_GEN]: 'Moderators',

  [PROMO_CODES]: 'Promo Codes',

  [BULK_UPLOAD]: 'Bulk Media Uploads',
  [DESIGN_REQUESTS]: 'Design Requests',
  [DESIGNERS]: 'Designers',
  [MY_DESIGN_REQUESTS]: 'My Design Requests',
  [DESIGN_REQUEST_RESULT_DETAILS_GEN]: 'Design Result Details',
  [DESIGN_REQUEST_DETAILS_GEN]: 'Design request Details',
  [DESIGN_REQUEST_RESULT_DETAILS]: 'Design Request Results',
  [DESIGN_REQUEST_DETAILS]: 'Design Request Details',
  [MERCH_SALES_REPORT]: 'Merch sales report',
  [AMA_SALES_REPORT]: 'AMA sales report',
  [STREAM_SALES_REPORT]: 'Stream sales report',
  [AFFILIATE_COMMISSIONS_REPORT]: 'Affiliate commissions',
  [AFFILIATE_STREAMS]: 'Affiliate streams',

  [EDITING_REQUESTS]: 'Editing Request',
  [MY_EDITING_REQUESTS]: 'My Editing Request',
  [VIDEO_EDITORS]: 'Video Editors',
  [VIDEO_EDITOR_PROFILE]: 'My Profile',
  [VIDEO_EDIT_REQUEST_SETTINGS]: 'Video Edit Request Settings',

  [MY_INTERVIEWS]: 'My Interviews',
  [MY_SCHEDULED_EVENTS]: 'My Scheduled Events',
  [MY_AVAILABILITY]: 'Availability',
  [INTERVIEWS]: 'Interviews',
  [INTERVIEW_CHATS]: 'Interview Chats',
  [INTERVIEWERS]: 'Interviewers',
  [INTERVIEW_SETTINGS]: 'Interview Settings',
  [INTERVIEW_NOW_TRANSITIONS]: 'Interview Now Transitions',
  [INTERVIEW_NOW_NOTIFICATIONS]: 'Interview Now Notifications',
  [CHANNEL_MONETIZATION]: 'Channel Monetization Programs',
  [CHANNEL_MONETIZATION_APPLICATIONS]: 'Channel Monetization Applications',
  [CHANNEL_MONETIZATION_LEADERBOARD]: 'Channel Monetization Leaderboard',
  [FEATURE_LIMITS]: 'Feature Limits',
  [ACTIVE_FEATURE_LIMITS]: 'Active Feature Limits',
  [AUDIT_LOGS]: 'Audit Logs',

  [AI_CLIPS]: 'AI Highlights',
  [AI_CLIP_DETAIL_GEN]: 'AI Clip Review',
  [AI_CLIP_DETAIL]: 'AI Clip Review',
  [AI_CLIPPER_METRICS]: 'AI Clipper Metrics',
  [AI_CLIPPER_SETTINGS]: 'AI Clipper Settings',
  [AI_POST_CLIPS]: 'AI Post Clips',
  [AI_POST_CLIP_DETAIL_GEN]: 'AI Post Clip Review',
  [AI_POST_CLIP_DETAIL]: 'AI Post Clip Review',

  [AI_PPV_CLIPS]: 'AI PPV Clips',
  [PPV_CLIP_ANALYTICS]: 'PPV Clip Analytics',
  [PPV_AUTO_FREE_SETTINGS]: 'PPV Auto-Free',
  [AI_PPV_CLIP_DETAIL_GEN]: 'AI PPV Clip Review',
  [AI_PPV_CLIP_DETAIL]: 'AI PPV Clip Review',

  [LIST_OF_ASSIGNED_STREAMS]: 'List of assigned streams',
  [GENERAL_SALES]: 'General sales',
  [EXPERIENCE_SALES]: 'Experience sales',
  [MANUAL_MERCH_MERGE]: 'Manual merch merge',
  [MANAGE_MESSAGES]: 'Messaging',
  [MANAGE_MESSAGES_WITH_PAGINATION]: 'Messages',
  [CAMPAIGNS]: 'Campaigns',
  [BRANDS]: 'Brands',
  [CREDIT_USAGE_REPORT]: 'Credit Usage Report',
  [CREDIT_USAGE_DETAILS_GEN]: 'Credit Usage Details',
  [INFLUENCER_CATEGORIES]: 'Influencer Categories',
  [PRODUCT_CATEGORIES]: 'Product Categories',
  [RESTRICTED_CATEGORIES]: 'Restricted Categories',
  [BRAND_DETAILS_GEN]: 'Brand Details',
  [BILLING_GEN]: 'Billing',
  [CB_SETTINGS_GEN]: 'CB Settings',
  [CB_TEAM_OWNERSHIP_GEN]: 'Transfer Team Ownership',
  [CB_PROMO_CODES]: 'CB Promo Codes',
  [CB_DIGITAL_AGREEMENT_SETTINGS]: 'Digital Agreement',
  [CB_SIGN_UP_SETTINGS]: 'Sign Up',
  [BRAND_PREFERENCES_GEN]: 'Preferences',
  [CAMPAIGN_DETAILS_GEN]: 'Campaign Details',
  [ADMINS]: 'Admins',
  [ACCOUNT]: 'Account',
  [REDIRECTS]: 'Redirects',
  [ARTICLES]: 'Articles',
  [ARTICLES_WITH_PAGINATION]: 'Articles',
  [CREATE_PROFILE]: 'Profile creation',
  [SOCIAL_MEDIA_INTEGRATION_SETTINGS]: 'Social Media Integration Settings',
};

type LayoutProps = {
  children?: React.ReactNode;
};

export const LayoutWrapper: React.FC = ({ children }: LayoutProps) => {
  const [menu, updateMenu] = useState<State>({
    collapsed: false,
  });
  const [mobileNavigationOpen, setMobileNavigationOpen] = useState(false);
  const navigationSearchRef = useRef<any>(null);
  const mobileNavigationToggleRef = useRef<HTMLButtonElement>(null);
  const { authUser, clearAuthUser } = useAppContext();
  const { launched: ticketingLaunched } = useTicketingLaunched();
  const match = useRouteMatch();
  const {
    storeId,
    customerId,
    streamId,
    manageMerchRole,
    campaignId,
    ownerId,
    agencyId,
    ticketEventId,
  } = useParams<{
    storeId?: string;
    customerId?: string;
    streamId?: string;
    manageMerchRole?: string;
    campaignId?: string;
    ownerId?: string;
    agencyId?: string;
    ticketEventId?: string;
  }>();
  const location = useLocation<LocationStateType>();
  const history = useHistory();
  const currentItem = LINKS_MENU[match.path];
  const pathName = `/${location.pathname.split('/')[1]}`;
  const isAdmin = authUser?.role === UserRole.Admin;
  const isDesigner = authUser?.role === UserRole.Designer;
  const isVideoEditor = authUser?.role === UserRole.VideoEditor;
  const isModerator = authUser?.role === UserRole.Moderator;
  const isInterviewer = authUser?.isInterviewer;

  const [signOut, { loading: signOutLoading }] = useMutation<
    SignOut,
    SignOutVariables
  >(SIGN_OUT);

  useEffect(() => {
    if (!mobileNavigationOpen) {
      return undefined;
    }

    navigationSearchRef.current?.focus();
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const handleEscape = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') {
        setMobileNavigationOpen(false);
        mobileNavigationToggleRef.current?.focus();
      }
      if (event.key === 'Tab') {
        const drawer = document.getElementById('workspace-navigation-drawer');
        const focusable = Array.from(
          drawer?.querySelectorAll<HTMLElement>(
            'a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]'
          ) || []
        ).filter((element) => element.getClientRects().length > 0);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      }
    };

    const handleResize = () => {
      if (window.innerWidth > 960) setMobileNavigationOpen(false);
    };

    window.addEventListener('keydown', handleEscape);
    window.addEventListener('resize', handleResize);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleEscape);
      window.removeEventListener('resize', handleResize);
    };
  }, [mobileNavigationOpen]);

  const onCollapse = (collapsed: boolean): void => {
    updateMenu(() => ({ collapsed }));
  };

  const handleMenuItemSelect = ({ key = '' }: { key: string }): void => {
    setMobileNavigationOpen(false);
    if (currentItem !== key) {
      let redirectLink = MENU_ITEMS_LINKS[key];

      if (
        MERCH_MENU_ITEMS.includes(key) ||
        ATHLETE_MENU_ITEMS.includes(key) ||
        ORGANIZATION_MENU_ITEMS.includes(key) ||
        CONTENT_CREATOR_MENU_ITEMS.includes(key)
      ) {
        redirectLink = `${MENU_ITEMS_LINKS[key]}/${storeId}`;
      }

      // TODO: uncomment it when "Watch Stream" menu will have at least one menu item
      // if (WATCH_STREAM_MENU_ITEMS.includes(key)) {
      //   redirectLink = `${MENU_ITEMS_LINKS[key]}/${streamId}`;
      // }

      if (CUSTOMER_MENU_ITEMS.includes(key)) {
        redirectLink = `${MENU_ITEMS_LINKS[key]}/${customerId}`;
      }

      if (key === MENU_ITEMS.CUSTOMERS_WITH_PAGINATION) {
        redirectLink = CUSTOMERS_DEFAULT_ROUTE;
      }

      if (key === MENU_ITEMS.ARTICLES_WITH_PAGINATION) {
        redirectLink = ARTICLES_DEFAULT_ROUTE;
      }

      if (key === MENU_ITEMS.EVENTS_WITH_TABS) {
        redirectLink = EVENTS_DEFAULT_ROUTE;
      }

      if (key === MENU_ITEMS.MANAGE_ATHLETES_STORES_WITH_PAGINATION) {
        redirectLink = MANAGE_ATHLETES_STORES_DEFAULT_ROUTE;
      }

      if (key === MENU_ITEMS.MANAGE_ORGANIZATIONS_STORES_WITH_PAGINATION) {
        redirectLink = MANAGE_ORGANIZATIONS_STORES_DEFAULT_ROUTE;
      }

      if (key === MENU_ITEMS.MANAGE_CONTENT_CREATORS_STORES_WITH_PAGINATION) {
        redirectLink = MANAGE_CONTENT_CREATORS_STORES_DEFAULT_ROUTE;
      }

      if (key === MENU_ITEMS.EXTERNAL_TALENTS) {
        redirectLink = EXTERNAL_TALENTS;
      }

      if (key === MENU_ITEMS.EXTERNAL_TALENT_IMPORT) {
        redirectLink = EXTERNAL_TALENT_IMPORT;
      }

      if (key === MENU_ITEMS.MANAGE_MESSAGES_WITH_PAGINATION) {
        redirectLink = MANAGE_MESSAGES_DEFAULT_ROUTE;
      }

      if (key === MENU_ITEMS.CAMPAIGNS) {
        redirectLink = CAMPAIGNS;
      }

      if (key === MENU_ITEMS.BRANDS) {
        redirectLink = BRANDS;
      }

      if (key === MENU_ITEMS.ARTICLES) {
        redirectLink = ARTICLES;
      }

      if (key === MENU_ITEMS.DESIGN_REQUESTS) {
        redirectLink = DESIGN_REQUESTS;
      }

      if (key === MENU_ITEMS.BULK_UPLOAD) {
        redirectLink = BULK_UPLOAD;
      }

      if (key === MENU_ITEMS.DESIGNERS) {
        redirectLink = DESIGNERS;
      }

      if (key === MENU_ITEMS.EDITING_REQUESTS) {
        redirectLink = EDITING_REQUESTS;
      }

      if (key === MENU_ITEMS.VIDEO_EDITORS) {
        redirectLink = VIDEO_EDITORS;
      }

      if (key === MENU_ITEMS.VIDEO_EDIT_REQUEST_SETTINGS) {
        redirectLink = VIDEO_EDIT_REQUEST_SETTINGS;
      }

      if (key === MENU_ITEMS.VIDEO_EDITOR_PROFILE) {
        redirectLink = VIDEO_EDITOR_PROFILE;
      }

      if (key === MENU_ITEMS.MY_EDITING_REQUESTS) {
        redirectLink = MY_EDITING_REQUESTS;
      }

      if (key === MENU_ITEMS.MANAGE_WATCH_STREAM_MODERATORS_GEN) {
        redirectLink = MANAGE_WATCH_STREAM_MODERATORS_GEN;
      }

      if (key === MENU_ITEMS.MY_DESIGN_REQUESTS) {
        redirectLink = MY_DESIGN_REQUESTS;
      }

      if (key === MENU_ITEMS.MY_INTERVIEWS) {
        redirectLink = MY_INTERVIEWS;
      }

      if (key === MENU_ITEMS.MY_SCHEDULED_EVENTS) {
        redirectLink = MY_SCHEDULED_EVENTS;
      }

      if (key === MENU_ITEMS.INTERVIEWS) {
        redirectLink = INTERVIEWS;
      }

      if (key === MENU_ITEMS.INTERVIEWERS) {
        redirectLink = INTERVIEWERS;
      }

      if (key === MENU_ITEMS.INTERVIEW_SETTINGS) {
        redirectLink = INTERVIEW_SETTINGS;
      }

      if (key === MENU_ITEMS.INTERVIEW_NOW_TRANSITIONS) {
        redirectLink = INTERVIEW_NOW_TRANSITIONS;
      }

      if (key === MENU_ITEMS.INTERVIEW_NOW_NOTIFICATIONS) {
        redirectLink = INTERVIEW_NOW_NOTIFICATIONS;
      }

      if (key === MENU_ITEMS.CHANNEL_MONETIZATION) {
        redirectLink = CHANNEL_MONETIZATION;
      }

      if (key === MENU_ITEMS.CHANNEL_MONETIZATION_APPLICATIONS) {
        redirectLink = CHANNEL_MONETIZATION_APPLICATIONS;
      }

      if (key === MENU_ITEMS.CHANNEL_MONETIZATION_LEADERBOARD) {
        redirectLink = CHANNEL_MONETIZATION_LEADERBOARD;
      }

      if (key === MENU_ITEMS.FEATURE_LIMITS) {
        redirectLink = FEATURE_LIMITS;
      }

      if (key === MENU_ITEMS.ACTIVE_FEATURE_LIMITS) {
        redirectLink = ACTIVE_FEATURE_LIMITS;
      }

      if (key === MENU_ITEMS.AUDIT_LOGS) {
        redirectLink = AUDIT_LOGS;
      }

      if (key === MENU_ITEMS.MY_AVAILABILITY) {
        redirectLink = MY_AVAILABILITY;
      }

      if (key === MENU_ITEMS.LIST_OF_ASSIGNED_STREAMS) {
        redirectLink = LIST_OF_ASSIGNED_STREAMS;
      }

      if (key === MENU_ITEMS.GENERAL_SALES) {
        redirectLink = GENERAL_SALES;
      }

      if (key === MENU_ITEMS.EXPERIENCE_SALES) {
        redirectLink = EXPERIENCE_SALES;
      }

      if (key === MENU_ITEMS.ADMINS) {
        redirectLink = ADMINS;
      }

      if (key === MENU_ITEMS.CREATE_PROFILE) {
        redirectLink = CREATE_PROFILE;
      }

      if (key === MENU_ITEMS.BRAND_DETAILS) {
        redirectLink = BRAND_DETAILS.replace(':ownerId', ownerId || '');
        // Save the original url parameters state
        const returnToBrands = (location.state as any)?.returnToBrands;
        if (returnToBrands) {
          history.push({
            pathname: redirectLink,
            state: { returnToBrands },
          });
          return;
        }
      }

      if (key === MENU_ITEMS.BILLING) {
        redirectLink = BILLING.replace(':ownerId', ownerId || '');
        // Save the original url parameters state
        const returnToBrands = (location.state as any)?.returnToBrands;
        if (returnToBrands) {
          history.push({
            pathname: redirectLink,
            state: { returnToBrands },
          });
          return;
        }
      }

      if (key === MENU_ITEMS.BRAND_PREFERENCES) {
        redirectLink = BRAND_PREFERENCES.replace(':ownerId', ownerId || '');
        // Save the original url parameters state
        const returnToBrands = (location.state as any)?.returnToBrands;
        if (returnToBrands) {
          history.push({
            pathname: redirectLink,
            state: { returnToBrands },
          });
          return;
        }
      }

      if (key === MENU_ITEMS.CB_SETTINGS) {
        redirectLink = CB_SETTINGS.replace(':ownerId', ownerId || '');
        // Save the original url parameters state
        const returnToBrands = (location.state as any)?.returnToBrands;
        if (returnToBrands) {
          history.push({
            pathname: redirectLink,
            state: { returnToBrands },
          });
          return;
        }
      }

      if (key === MENU_ITEMS.CB_TEAM_OWNERSHIP) {
        redirectLink = CB_TEAM_OWNERSHIP.replace(':ownerId', ownerId || '');
        // Save the original url parameters state
        const returnToBrands = (location.state as any)?.returnToBrands;
        if (returnToBrands) {
          history.push({
            pathname: redirectLink,
            state: { returnToBrands },
          });
          return;
        }
      }

      history.push(redirectLink);
    }
  };

  const handleLogout = async (): Promise<void> => {
    if (authUser?.refreshToken) {
      await signOut({
        variables: {
          input: {
            refreshToken: authUser.refreshToken,
          },
        },
      });
    }

    clearAuthUser();
    history.push(LOGIN);
  };

  const handleGoToAccountPage = (): void => {
    history.push(ACCOUNT);
  };

  const handleGoBack = (): void => {
    // "manageMerchRole" param as an indicator of the create/edit merch page
    if (manageMerchRole) {
      history.push(`/${manageMerchRole}/${storeId}`);
    } else if (storeId) {
      history.push(
        pathName.includes(STORE_TYPE.ORGANIZATION)
          ? MANAGE_ORGANIZATIONS_STORES_DEFAULT_ROUTE
          : pathName.includes('content-creator')
          ? MANAGE_CONTENT_CREATORS_STORES_DEFAULT_ROUTE
          : MANAGE_ATHLETES_STORES_DEFAULT_ROUTE
      );
    }

    if (customerId) {
      history.push(CUSTOMERS_DEFAULT_ROUTE);
    }

    if (streamId) {
      if (location.state?.fromCalendar) {
        history.push(STREAMS_CALENDAR);
      } else {
        history.push(ALL_STREAMS_TABLE);
      }
    }

    if (campaignId) {
      history.push(CAMPAIGNS);
    }

    if (ownerId) {
      const returnToBrands = (location.state as any)?.returnToBrands;
      if (returnToBrands) {
        history.push(returnToBrands);
      } else {
        history.push(BRANDS);
      }
    }

    if (agencyId) {
      const returnTo = (location.state as any)?.returnTo;
      if (returnTo) {
        history.push(returnTo);
      } else {
        history.push(CREDIT_USAGE_REPORT);
      }
    }

    if (ticketEventId) {
      history.push(
        pathName === EDIT_TICKET_EVENT_GEN
          ? `${TICKET_EVENT_DETAILS_GEN}/${ticketEventId}`
          : EVENTS_DEFAULT_ROUTE
      );
    }
  };

  const renderMenuItem = (
    key: keyof typeof MENU_ITEMS,
    icon: JSX.Element,
    title: string
  ) => (
    <Menu.Item key={MENU_ITEMS[key]} icon={icon}>
      {title}
    </Menu.Item>
  );

  const getBasicMenu = () => {
    const defaultOpenKeys = (): string[] | undefined => {
      switch (currentItem) {
        case MENU_ITEMS.MANAGE_ATHLETES_STORES_WITH_PAGINATION:
          return ['manage-store'];
        case MENU_ITEMS.MANAGE_ORGANIZATIONS_STORES_WITH_PAGINATION:
          return ['manage-store'];
        case MENU_ITEMS.MANAGE_CONTENT_CREATORS_STORES_WITH_PAGINATION:
        case MENU_ITEMS.EXTERNAL_TALENTS:
        case MENU_ITEMS.EXTERNAL_TALENT_IMPORT:
          return ['manage-store'];
        case MENU_ITEMS.STREAMS_CALENDAR:
          return ['streams'];
        case MENU_ITEMS.ALL_STREAMS_TABLE:
          return ['streams'];
        case MENU_ITEMS.MANAGE_WATCH_STREAM_MODERATORS_GEN:
          return ['streams'];
        case MENU_ITEMS.DESIGN_REQUESTS:
          return ['design-lab'];
        case MENU_ITEMS.DESIGNERS:
          return ['design-lab'];
        case MENU_ITEMS.EDITING_REQUESTS:
          return ['video-lab'];
        case MENU_ITEMS.VIDEO_EDITORS:
          return ['video-lab'];
        case MENU_ITEMS.VIDEO_EDIT_REQUEST_SETTINGS:
          return ['video-lab'];
        case MENU_ITEMS.MERCH_SALES_REPORT:
          return ['reports'];
        case MENU_ITEMS.AMA_SALES_REPORT:
          return ['reports'];
        case MENU_ITEMS.STREAM_SALES_REPORT:
          return ['reports'];
        case MENU_ITEMS.AFFILIATE_COMMISSIONS_REPORT:
          return ['reports'];
        case MENU_ITEMS.MANAGE_MESSAGES_WITH_PAGINATION:
          return ['manage-messages'];
        case MENU_ITEMS.CAMPAIGNS:
          return ['manage-campaigns'];
        case MENU_ITEMS.CB_PROMO_CODES:
          return ['manage-campaigns'];
        case MENU_ITEMS.CB_DIGITAL_AGREEMENT_SETTINGS:
          return ['manage-campaigns'];
        case MENU_ITEMS.CB_SIGN_UP_SETTINGS:
          return ['manage-campaigns'];
        case MENU_ITEMS.BRANDS:
          return ['manage-campaigns'];
        case MENU_ITEMS.CREDIT_USAGE_REPORT:
          return ['manage-campaigns'];
        case MENU_ITEMS.INFLUENCER_CATEGORIES:
          return ['manage-campaigns'];
        case MENU_ITEMS.PRODUCT_CATEGORIES:
          return ['manage-campaigns'];
        case MENU_ITEMS.RESTRICTED_CATEGORIES:
          return ['manage-campaigns'];
        case MENU_ITEMS.INTERVIEW_SETTINGS:
          return ['interviews-submenu'];
        case MENU_ITEMS.INTERVIEW_NOW_TRANSITIONS:
          return ['interviews-submenu'];
        case MENU_ITEMS.INTERVIEW_NOW_NOTIFICATIONS:
          return ['interviews-submenu'];
        case MENU_ITEMS.INTERVIEWS:
          return ['interviews-submenu'];
        case MENU_ITEMS.INTERVIEW_CHATS:
          return ['interviews-submenu'];
        case MENU_ITEMS.INTERVIEWERS:
          return ['interviews-submenu'];
        case MENU_ITEMS.AI_CLIPS:
          return ['interviews-submenu'];
        case MENU_ITEMS.AI_CLIPPER_METRICS:
          return ['interviews-submenu'];
        case MENU_ITEMS.AI_CLIPPER_SETTINGS:
          return ['interviews-submenu'];
        case MENU_ITEMS.AI_POST_CLIPS:
          return ['interviews-submenu'];
        case MENU_ITEMS.AI_POST_CLIP_DETAIL:
          return ['interviews-submenu'];
        case MENU_ITEMS.AI_PPV_CLIPS:
          return ['streams'];
        case MENU_ITEMS.PPV_CLIP_ANALYTICS:
          return ['streams'];
        case MENU_ITEMS.PPV_AUTO_FREE_SETTINGS:
          return ['streams'];
        case MENU_ITEMS.CHANNEL_MONETIZATION:
          return ['channel-monetization-submenu'];
        case MENU_ITEMS.CHANNEL_MONETIZATION_APPLICATIONS:
          return ['channel-monetization-submenu'];
        case MENU_ITEMS.CHANNEL_MONETIZATION_LEADERBOARD:
          return ['channel-monetization-submenu'];
        case MENU_ITEMS.FEATURE_LIMITS:
          return ['feature-limits-submenu'];
        case MENU_ITEMS.ACTIVE_FEATURE_LIMITS:
          return ['feature-limits-submenu'];
        case MENU_ITEMS.ARTICLES:
          return ['articles'];
        case MENU_ITEMS.ARTICLES_WITH_PAGINATION:
          return ['articles'];
        default:
          return undefined;
      }
    };

    return (
      <Menu
        key="basic-navigation"
        theme="dark"
        mode="inline"
        selectedKeys={[currentItem]}
        defaultOpenKeys={defaultOpenKeys()}
        onSelect={handleMenuItemSelect}
        className={styles.menu}
      >
        <Menu.ItemGroup key="overview-group" title="Overview">
          {renderMenuItem('DASHBOARD', <DashboardOutlined />, 'Dashboard')}
          {renderMenuItem(
            'HOME_PAGE_MANAGEMENT',
            <PicCenterOutlined />,
            'Home Page Management'
          )}
          {renderMenuItem(
            'FEATURED_STREAMS',
            <PicCenterOutlined />,
            'Featured Streams Management'
          )}
        </Menu.ItemGroup>

        <Menu.ItemGroup key="people-group" title="People">
          {renderMenuItem('ADMINS', <UserOutlined />, 'Admins')}
          <SubMenu
            key="manage-store"
            icon={<ControlOutlined />}
            title="Manage Store"
          >
            {renderMenuItem(
              'MANAGE_ATHLETES_STORES_WITH_PAGINATION',
              <TeamOutlined />,
              'Athletes'
            )}
            {renderMenuItem(
              'MANAGE_ORGANIZATIONS_STORES_WITH_PAGINATION',
              <DribbbleOutlined />,
              'Organizations'
            )}
            {renderMenuItem(
              'MANAGE_CONTENT_CREATORS_STORES_WITH_PAGINATION',
              <DribbbleOutlined />,
              'Content Creators'
            )}
            {renderMenuItem(
              'EXTERNAL_TALENTS',
              <TeamOutlined />,
              'External Talents'
            )}
          </SubMenu>
          {renderMenuItem(
            'CUSTOMERS_WITH_PAGINATION',
            <TeamOutlined />,
            'Customers'
          )}
          {renderMenuItem(
            'CREATE_PROFILE',
            <UserAddOutlined />,
            'Create User Profile'
          )}
        </Menu.ItemGroup>

        <Menu.ItemGroup key="campaigns-group" title="Campaigns">
          <SubMenu
            key="manage-campaigns"
            icon={<ControlOutlined />}
            title="Manage Campaigns"
          >
            {renderMenuItem('CAMPAIGNS', <TeamOutlined />, 'Campaigns')}
            {renderMenuItem('BRANDS', <TeamOutlined />, 'Brands')}
            {renderMenuItem(
              'CB_PROMO_CODES',
              <BarcodeOutlined />,
              'CB Promo Codes'
            )}
            {renderMenuItem(
              'CB_DIGITAL_AGREEMENT_SETTINGS',
              <AuditOutlined />,
              'Digital Agreement'
            )}
            {renderMenuItem('CB_SIGN_UP_SETTINGS', <MailOutlined />, 'Sign Up')}
            {renderMenuItem(
              'CREDIT_USAGE_REPORT',
              <TableOutlined />,
              'Reports'
            )}
            {renderMenuItem(
              'INFLUENCER_CATEGORIES',
              <UnorderedListOutlined />,
              'Influencer Categories'
            )}
            {renderMenuItem(
              'PRODUCT_CATEGORIES',
              <UnorderedListOutlined />,
              'Product Categories'
            )}
            {renderMenuItem(
              'RESTRICTED_CATEGORIES',
              <UnorderedListOutlined />,
              'Restricted Categories'
            )}
          </SubMenu>
          {renderMenuItem('PROMO_CODES', <BarcodeOutlined />, 'Promo Codes')}
        </Menu.ItemGroup>

        <Menu.ItemGroup key="content-group" title="Content">
          {renderMenuItem('TAGS', <BorderlessTableOutlined />, 'Manage Tags')}
          {renderMenuItem(
            'MANAGE_MESSAGES_WITH_PAGINATION',
            <MessageOutlined />,
            'Messaging'
          )}
          {renderMenuItem(
            'ARTICLES_WITH_PAGINATION',
            <FileTextOutlined />,
            'Articles'
          )}
          {renderMenuItem(
            'ALL_PRODUCT_MEMORABILIA',
            <SkinOutlined />,
            'Memorabilia'
          )}
          {renderMenuItem(
            'ALL_AMA_REQUESTS',
            <CarryOutOutlined />,
            'AMA Requests'
          )}
          <SubMenu
            key="interviews-submenu"
            icon={<AudioOutlined />}
            title="Interviews"
          >
            {renderMenuItem(
              'INTERVIEWS',
              <UnorderedListOutlined />,
              'All interviews'
            )}
            {renderMenuItem(
              'INTERVIEW_CHATS',
              <MessageOutlined />,
              'Interview Chats'
            )}
            {renderMenuItem('INTERVIEWERS', <TeamOutlined />, 'Interviewers')}
            {renderMenuItem(
              'INTERVIEW_SETTINGS',
              <TeamOutlined />,
              'Interview settings'
            )}
            {renderMenuItem(
              'INTERVIEW_NOW_TRANSITIONS',
              <PlaySquareOutlined />,
              'Interview Now Transitions'
            )}
            {renderMenuItem(
              'INTERVIEW_NOW_NOTIFICATIONS',
              <BellOutlined />,
              'Interview Now Notifications'
            )}
            {renderMenuItem('AI_CLIPS', <ScissorOutlined />, 'AI Highlights')}
            {renderMenuItem(
              'AI_POST_CLIPS',
              <ScissorOutlined />,
              'AI Post Clips'
            )}
            {renderMenuItem(
              'AI_CLIPPER_METRICS',
              <BarChartOutlined />,
              'AI Clipper Metrics'
            )}
            {renderMenuItem(
              'AI_CLIPPER_SETTINGS',
              <SettingOutlined />,
              'AI Clipper Settings'
            )}
          </SubMenu>
          {ticketingLaunched &&
            renderMenuItem('EVENTS_WITH_TABS', <ScheduleOutlined />, 'Events')}
          {renderMenuItem(
            'TICKETING_SETTINGS',
            <SettingOutlined />,
            'Ticketing Settings'
          )}
          <SubMenu key="streams" icon={<VideoCameraOutlined />} title="Streams">
            {renderMenuItem(
              'STREAMS_CALENDAR',
              <CalendarOutlined />,
              'Calendar'
            )}
            {renderMenuItem(
              'ALL_STREAMS_TABLE',
              <TableOutlined />,
              'All Streams'
            )}
            {renderMenuItem(
              'AI_PPV_CLIPS',
              <ScissorOutlined />,
              'AI PPV Clips'
            )}
            {renderMenuItem(
              'PPV_CLIP_ANALYTICS',
              <BarChartOutlined />,
              'PPV Clip Analytics'
            )}
            {renderMenuItem(
              'PPV_AUTO_FREE_SETTINGS',
              <UnlockOutlined />,
              'PPV Auto-Free'
            )}
            {renderMenuItem(
              'MANAGE_WATCH_STREAM_MODERATORS_GEN',
              <TeamOutlined />,
              'Moderators'
            )}
          </SubMenu>
          {renderMenuItem(
            'AFFILIATE_STREAMS',
            <ShareAltOutlined />,
            'Affiliate Streams'
          )}
          <SubMenu
            key="design-lab"
            icon={<FormatPainterOutlined />}
            title="Design lab"
          >
            {renderMenuItem(
              'DESIGN_REQUESTS',
              <AuditOutlined />,
              'Design Requests'
            )}
            {renderMenuItem('DESIGNERS', <TeamOutlined />, 'Designers')}
          </SubMenu>
          <SubMenu
            key="video-lab"
            icon={<PlaySquareOutlined />}
            title="Video lab"
          >
            {renderMenuItem(
              'EDITING_REQUESTS',
              <AuditOutlined />,
              'Editing Requests'
            )}
            {renderMenuItem('VIDEO_EDITORS', <TeamOutlined />, 'Video Editors')}
            {renderMenuItem(
              'VIDEO_EDIT_REQUEST_SETTINGS',
              <TeamOutlined />,
              'Video Edit Request Settings'
            )}
          </SubMenu>
          {renderMenuItem(
            'BULK_UPLOAD',
            <CarryOutOutlined />,
            'Bulk media upload'
          )}
        </Menu.ItemGroup>

        <Menu.ItemGroup key="commerce-group" title="Commerce">
          <SubMenu
            key="channel-monetization-submenu"
            icon={<DollarOutlined />}
            title="Channel Monetization"
          >
            {renderMenuItem(
              'CHANNEL_MONETIZATION',
              <ReconciliationOutlined />,
              'Programs'
            )}
            {renderMenuItem(
              'CHANNEL_MONETIZATION_APPLICATIONS',
              <AuditOutlined />,
              'Applications'
            )}
            {renderMenuItem(
              'CHANNEL_MONETIZATION_LEADERBOARD',
              <TrophyOutlined />,
              'Leaderboard'
            )}
          </SubMenu>
          {renderMenuItem('GENERAL_SALES', <DollarOutlined />, 'General sales')}
          {renderMenuItem(
            'EXPERIENCE_SALES',
            <DollarOutlined />,
            'Experience sales'
          )}
          {renderMenuItem(
            'MANUAL_MERCH_MERGE',
            <SkinOutlined />,
            'Manual merch merge'
          )}
        </Menu.ItemGroup>

        <Menu.ItemGroup key="reports-group" title="Reports">
          <SubMenu key="reports" icon={<TableOutlined />} title="Reports">
            {renderMenuItem(
              'MERCH_SALES_REPORT',
              <TableOutlined />,
              'Merch Sales'
            )}
            {renderMenuItem('AMA_SALES_REPORT', <TableOutlined />, 'Ama Sales')}
            {renderMenuItem(
              'STREAM_SALES_REPORT',
              <TableOutlined />,
              'Stream Sales'
            )}
            {renderMenuItem(
              'AFFILIATE_COMMISSIONS_REPORT',
              <TableOutlined />,
              'Affiliate Commissions'
            )}
          </SubMenu>
          {renderMenuItem('AUDIT_LOGS', <AuditOutlined />, 'Audit Logs')}
        </Menu.ItemGroup>

        <Menu.ItemGroup key="settings-group" title="Settings">
          <SubMenu
            key="feature-limits-submenu"
            icon={<ControlOutlined />}
            title="Feature Limits"
          >
            {renderMenuItem(
              'FEATURE_LIMITS',
              <SettingOutlined />,
              'Configuration'
            )}
            {renderMenuItem(
              'ACTIVE_FEATURE_LIMITS',
              <TableOutlined />,
              'Active Limits'
            )}
          </SubMenu>
          {renderMenuItem(
            'ENGAGEMENT_NOTIFICATION_SETTINGS',
            <BellOutlined />,
            'Like & Comment Notifications'
          )}
          {renderMenuItem(
            'SOCIAL_MEDIA_INTEGRATION_SETTINGS',
            <ShareAltOutlined />,
            'Social Media Integration Settings'
          )}
          {renderMenuItem('REDIRECTS', <RedoOutlined />, 'Redirects')}
        </Menu.ItemGroup>
      </Menu>
    );
  };

  const getAthleteMenu = () => {
    const defaultOpenKeys = (): string[] | undefined => {
      switch (currentItem) {
        case MENU_ITEMS.SETUP_ATHLETE_AMA:
          return ['manage-ama'];
        case MENU_ITEMS.MANAGE_ATHLETE_AMA_REQUESTS:
          return ['manage-ama'];
        case MENU_ITEMS.ATHLETE_DEALS_SETUP:
          return ['manage-deals'];
        case MENU_ITEMS.SETUP_ATHLETE_STREAM:
          return ['streams'];
        case MENU_ITEMS.MANAGE_ATHLETE_SCHEDULED_STREAMS:
          return ['streams'];
        default:
          return undefined;
      }
    };

    return (
      <Menu
        key="athlete-navigation"
        theme="dark"
        mode="inline"
        selectedKeys={[currentItem]}
        defaultOpenKeys={defaultOpenKeys()}
        onSelect={handleMenuItemSelect}
        className={styles.menu}
      >
        {renderMenuItem(
          'ATHLETE_DASHBOARD',
          <DashboardOutlined />,
          'Dashboard'
        )}

        {renderMenuItem(
          'MANAGE_ATHLETE_MARGINS',
          <AuditOutlined />,
          'Manage Margins'
        )}

        {renderMenuItem(
          'MANAGE_ATHLETE_MERCH',
          <SkinOutlined />,
          'Manage Merch'
        )}

        {renderMenuItem(
          'MANAGE_ATHLETE_PRODUCTS',
          <SkinOutlined />,
          'Manage Memorabilia'
        )}

        {renderMenuItem(
          'MANAGE_ATHLETE_EXPERIENCE',
          <SkinOutlined />,
          'Manage Experience'
        )}

        {renderMenuItem(
          'MANAGE_ATHLETE_DESIGNS',
          <FormatPainterOutlined />,
          'Manage Designs'
        )}

        <SubMenu
          key="manage-ama"
          icon={<ReconciliationOutlined />}
          title="Manage AMA"
        >
          {renderMenuItem(
            'SETUP_ATHLETE_AMA',
            <SlidersOutlined />,
            'Setup AMA'
          )}
          {renderMenuItem(
            'MANAGE_ATHLETE_AMA_REQUESTS',
            <CarryOutOutlined />,
            'Requests'
          )}
        </SubMenu>

        <SubMenu
          key="manage-deals"
          icon={<ReconciliationOutlined />}
          title="Manage Deals"
        >
          {renderMenuItem(
            'ATHLETE_DEALS_SETUP',
            <SlidersOutlined />,
            'Set Brand Deals'
          )}
        </SubMenu>

        <SubMenu key="streams" icon={<EyeOutlined />} title="Manage Streams">
          {renderMenuItem(
            'SETUP_ATHLETE_STREAM',
            <SlidersOutlined />,
            'Setup Stream'
          )}
          {renderMenuItem(
            'MANAGE_ATHLETE_SCHEDULED_STREAMS',
            <CarryOutOutlined />,
            'Streams'
          )}
        </SubMenu>

        {renderMenuItem(
          'MANAGE_ATHLETE_BIO',
          <ProfileOutlined />,
          'Manage bio'
        )}

        {renderMenuItem('MEDIA_FEED_ATHLETE', <UploadOutlined />, 'Media Feed')}

        {renderMenuItem('ATHLETE_STORE_SALES', <DollarOutlined />, 'Sales')}

        {renderMenuItem(
          'ATHLETE_SCHEDULED_EVENTS',
          <CalendarOutlined />,
          'Scheduled Events'
        )}
        {ticketingLaunched &&
          renderMenuItem(
            'ATHLETE_TICKETED_EVENTS',
            <ScheduleOutlined />,
            'Ticketed Events'
          )}
      </Menu>
    );
  };

  const getOrganizationMenu = () => {
    const defaultOpenKeys = (): string[] | undefined => {
      switch (currentItem) {
        case MENU_ITEMS.SETUP_ORGANIZATION_AMA:
          return ['manage-ama'];
        case MENU_ITEMS.MANAGE_ORGANIZATION_AMA_REQUESTS:
          return ['manage-ama'];
        case MENU_ITEMS.SETUP_ORGANIZATION_STREAM:
          return ['streams'];
        case MENU_ITEMS.MANAGE_ORGANIZATION_SCHEDULED_STREAMS:
          return ['streams'];
        default:
          return undefined;
      }
    };

    return (
      <Menu
        key="organization-navigation"
        theme="dark"
        mode="inline"
        selectedKeys={[currentItem]}
        defaultOpenKeys={defaultOpenKeys()}
        onSelect={handleMenuItemSelect}
        className={styles.menu}
      >
        {renderMenuItem(
          'ORGANIZATION_DASHBOARD',
          <DashboardOutlined />,
          'Dashboard'
        )}
        {renderMenuItem(
          'MANAGE_ORGANIZATION_MARGINS',
          <AuditOutlined />,
          'Manage Margins'
        )}
        {renderMenuItem(
          'MANAGE_ORGANIZATION_MERCH',
          <SkinOutlined />,
          'Manage Merch'
        )}
        {renderMenuItem(
          'MANAGE_ORGANIZATION_PRODUCTS',
          <SkinOutlined />,
          'Manage Memorabilia'
        )}
        {renderMenuItem(
          'MANAGE_ORGANIZATION_EXPERIENCE',
          <SkinOutlined />,
          'Manage Experience'
        )}

        {renderMenuItem(
          'MANAGE_ORGANIZATION_DESIGNS',
          <FormatPainterOutlined />,
          'Manage Designs'
        )}

        <SubMenu
          key="manage-ama"
          icon={<ReconciliationOutlined />}
          title="Manage AMA"
        >
          {renderMenuItem(
            'SETUP_ORGANIZATION_AMA',
            <SlidersOutlined />,
            'Setup AMA'
          )}
          {renderMenuItem(
            'MANAGE_ORGANIZATION_AMA_REQUESTS',
            <CarryOutOutlined />,
            'Requests'
          )}
        </SubMenu>

        <SubMenu key="streams" icon={<EyeOutlined />} title="Manage Streams">
          {renderMenuItem(
            'SETUP_ORGANIZATION_STREAM',
            <SlidersOutlined />,
            'Setup Stream'
          )}
          {renderMenuItem(
            'MANAGE_ORGANIZATION_SCHEDULED_STREAMS',
            <CarryOutOutlined />,
            'Streams'
          )}
        </SubMenu>

        {renderMenuItem(
          'MANAGE_ORGANIZATION_BIO',
          <ProfileOutlined />,
          'Manage bio'
        )}

        {renderMenuItem(
          'MEDIA_FEED_ORGANIZATION',
          <UploadOutlined />,
          'Media Feed'
        )}

        {renderMenuItem(
          'ORGANIZATION_STORE_SALES',
          <DollarOutlined />,
          'Sales'
        )}

        {renderMenuItem(
          'ORGANIZATION_SCHEDULED_EVENTS',
          <CalendarOutlined />,
          'Scheduled Events'
        )}
        {ticketingLaunched &&
          renderMenuItem(
            'ORGANIZATION_TICKETED_EVENTS',
            <ScheduleOutlined />,
            'Ticketed Events'
          )}
      </Menu>
    );
  };

  const getContentCreatorMenu = () => {
    const defaultOpenKeys = (): string[] | undefined => {
      switch (currentItem) {
        case MENU_ITEMS.SETUP_CONTENT_CREATOR_AMA:
          return ['manage-ama'];
        case MENU_ITEMS.MANAGE_CONTENT_CREATOR_AMA_REQUESTS:
          return ['manage-ama'];
        case MENU_ITEMS.CONTENT_CREATOR_DEALS_SETUP:
          return ['manage-deals'];
        case MENU_ITEMS.SETUP_CONTENT_CREATOR_STREAM:
          return ['streams'];
        case MENU_ITEMS.MANAGE_CONTENT_CREATOR_SCHEDULED_STREAMS:
          return ['streams'];
        default:
          return undefined;
      }
    };

    return (
      <Menu
        key="content-creator-navigation"
        theme="dark"
        mode="inline"
        selectedKeys={[currentItem]}
        defaultOpenKeys={defaultOpenKeys()}
        onSelect={handleMenuItemSelect}
        className={styles.menu}
      >
        {renderMenuItem(
          'CONTENT_CREATOR_DASHBOARD',
          <DashboardOutlined />,
          'Dashboard'
        )}
        {renderMenuItem(
          'MANAGE_CONTENT_CREATOR_MARGINS',
          <AuditOutlined />,
          'Manage Margins'
        )}
        {renderMenuItem(
          'MANAGE_CONTENT_CREATOR_MERCH',
          <SkinOutlined />,
          'Manage Merch'
        )}
        {renderMenuItem(
          'MANAGE_CONTENT_CREATOR_PRODUCTS',
          <SkinOutlined />,
          'Manage Memorabilia'
        )}
        {renderMenuItem(
          'MANAGE_CONTENT_CREATOR_EXPERIENCE',
          <SkinOutlined />,
          'Manage Experience'
        )}

        {renderMenuItem(
          'MANAGE_CONTENT_CREATOR_DESIGNS',
          <FormatPainterOutlined />,
          'Manage Designs'
        )}

        <SubMenu
          key="manage-ama"
          icon={<ReconciliationOutlined />}
          title="Manage AMA"
        >
          {renderMenuItem(
            'SETUP_CONTENT_CREATOR_AMA',
            <SlidersOutlined />,
            'Setup AMA'
          )}
          {renderMenuItem(
            'MANAGE_CONTENT_CREATOR_AMA_REQUESTS',
            <CarryOutOutlined />,
            'Requests'
          )}
        </SubMenu>

        <SubMenu
          key="manage-deals"
          icon={<ReconciliationOutlined />}
          title="Manage Deals"
        >
          {renderMenuItem(
            'CONTENT_CREATOR_DEALS_SETUP',
            <SlidersOutlined />,
            'Set Brand Deals'
          )}
        </SubMenu>

        <SubMenu key="streams" icon={<EyeOutlined />} title="Manage Streams">
          {renderMenuItem(
            'SETUP_CONTENT_CREATOR_STREAM',
            <SlidersOutlined />,
            'Setup Stream'
          )}
          {renderMenuItem(
            'MANAGE_CONTENT_CREATOR_SCHEDULED_STREAMS',
            <CarryOutOutlined />,
            'Streams'
          )}
        </SubMenu>

        {renderMenuItem(
          'MANAGE_CONTENT_CREATOR_BIO',
          <ProfileOutlined />,
          'Manage bio'
        )}

        {renderMenuItem(
          'MEDIA_FEED_CONTENT_CREATOR',
          <UploadOutlined />,
          'Media Feed'
        )}

        {renderMenuItem(
          'CONTENT_CREATOR_STORE_SALES',
          <DollarOutlined />,
          'Sales'
        )}

        {renderMenuItem(
          'CONTENT_CREATOR_SCHEDULED_EVENTS',
          <CalendarOutlined />,
          'Scheduled Events'
        )}
        {ticketingLaunched &&
          renderMenuItem(
            'CONTENT_CREATOR_TICKETED_EVENTS',
            <ScheduleOutlined />,
            'Ticketed Events'
          )}
      </Menu>
    );
  };

  const getManagedStoreMenu = () => {
    if (pathName.includes(STORE_TYPE.ATHLETE)) {
      return getAthleteMenu();
    } else if (pathName.includes(STORE_TYPE.ORGANIZATION)) {
      return getOrganizationMenu();
    } else if (pathName.includes('content-creator')) {
      return getContentCreatorMenu();
    }
  };

  const getManagedCustomerMenu = () => {
    return (
      <Menu
        key="customer-navigation"
        theme="dark"
        mode="inline"
        selectedKeys={[currentItem]}
        onSelect={handleMenuItemSelect}
        className={styles.menu}
      >
        {renderMenuItem(
          'CUSTOMER_PURCHASES',
          <ShoppingOutlined />,
          'Purchases'
        )}
        {renderMenuItem('CUSTOMER_ADDRESSES', <HomeOutlined />, 'Addresses')}
        {renderMenuItem('CUSTOMER_SETTINGS', <ControlOutlined />, 'Settings')}
        {renderMenuItem(
          'CUSTOMER_PAYMENT',
          <DollarOutlined />,
          'Payment Options'
        )}
      </Menu>
    );
  };

  const getWatchStreamMenu = () => {
    return <React.Fragment key="watch-stream-navigation" />;
    // TODO: uncomment it when "Watch Stream" menu will have at least one menu item
    // return (
    //   <Menu
    //     theme="dark"
    //     mode="inline"
    //     selectedKeys={[currentItem]}
    //     onSelect={handleMenuItemSelect}
    //     className={styles.menu}
    //   />
    // );
  };

  const getDesignerMenu = () => {
    return (
      <Menu
        key="designer-navigation"
        theme="dark"
        mode="inline"
        selectedKeys={[currentItem]}
        onSelect={handleMenuItemSelect}
        className={styles.menu}
      >
        {renderMenuItem(
          'MY_DESIGN_REQUESTS',
          <AuditOutlined />,
          'My Design Requests'
        )}
      </Menu>
    );
  };

  const getInterviewerMenu = () => {
    return (
      <Menu
        key="interviewer-navigation"
        theme="dark"
        mode="inline"
        selectedKeys={[currentItem]}
        onSelect={handleMenuItemSelect}
        className={styles.menu}
      >
        {renderMenuItem('MY_INTERVIEWS', <AuditOutlined />, 'My Interviews')}
        {renderMenuItem(
          'MY_SCHEDULED_EVENTS',
          <AuditOutlined />,
          'My Scheduled Events'
        )}
        {renderMenuItem('MY_AVAILABILITY', <AuditOutlined />, 'Availability')}
      </Menu>
    );
  };

  const getVideoEditorMenu = () => {
    return (
      <Menu
        key="video-editor-navigation"
        theme="dark"
        mode="inline"
        selectedKeys={[currentItem]}
        onSelect={handleMenuItemSelect}
        className={styles.menu}
      >
        {renderMenuItem(
          'MY_EDITING_REQUESTS',
          <AuditOutlined />,
          'My Video Editor Request'
        )}
        {renderMenuItem(
          'VIDEO_EDITOR_PROFILE',
          <AuditOutlined />,
          'My Profile'
        )}
      </Menu>
    );
  };

  const getBrandDetailsMenu = () => {
    return (
      <Menu
        key="brand-navigation"
        theme="dark"
        mode="inline"
        selectedKeys={[currentItem]}
        onSelect={handleMenuItemSelect}
        className={styles.menu}
      >
        {renderMenuItem('BRAND_DETAILS', <ProfileOutlined />, 'Brand Details')}
        {renderMenuItem('BILLING', <DollarOutlined />, 'Billing')}
        {renderMenuItem('CB_SETTINGS', <ControlOutlined />, 'CB Settings')}
        {renderMenuItem(
          'CB_TEAM_OWNERSHIP',
          <SwapOutlined />,
          'Transfer Team Ownership'
        )}
        {renderMenuItem(
          'BRAND_PREFERENCES',
          <SlidersOutlined />,
          'Preferences'
        )}
      </Menu>
    );
  };

  const getModeratorMenu = () => {
    return (
      <Menu
        key="moderator-navigation"
        theme="dark"
        mode="inline"
        selectedKeys={[currentItem]}
        onSelect={handleMenuItemSelect}
        className={styles.menu}
      >
        {renderMenuItem(
          'LIST_OF_ASSIGNED_STREAMS',
          <AuditOutlined />,
          'List of assigned streams'
        )}
      </Menu>
    );
  };

  const hasContextualBackNavigation = Boolean(
    storeId ||
      customerId ||
      streamId ||
      campaignId ||
      ownerId ||
      agencyId ||
      ticketEventId
  );
  const pageTitle =
    PAGE_TITLES[match.path] ||
    PAGE_TITLES[pathName] ||
    pathName
      .slice(1)
      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, (letter) => letter.toUpperCase());
  const breadcrumbParent = storeId
    ? 'Stores'
    : customerId
    ? 'Customers'
    : streamId
    ? 'Streams'
    : campaignId
    ? 'Campaigns'
    : ownerId
    ? 'Brands'
    : agencyId
    ? 'Credit usage'
    : ticketEventId
    ? 'Events'
    : 'Workspace';
  const availableNavigation = [
    isAdmin &&
    !storeId &&
    !customerId &&
    !streamId &&
    !campaignId &&
    !ownerId &&
    !agencyId
      ? getBasicMenu()
      : null,
    isAdmin && storeId && !manageMerchRole ? getManagedStoreMenu() : null,
    isAdmin && customerId ? getManagedCustomerMenu() : null,
    isAdmin && streamId ? getWatchStreamMenu() : null,
    isAdmin &&
    (pathName.includes('/brand-details') ||
      pathName.includes('/billing') ||
      pathName.includes('/cb-settings') ||
      pathName.includes('/cb-team-ownership') ||
      pathName.includes('/brand-preferences'))
      ? getBrandDetailsMenu()
      : null,
    isDesigner ? getDesignerMenu() : null,
    isVideoEditor ? getVideoEditorMenu() : null,
    isModerator ? getModeratorMenu() : null,
    isInterviewer ? getInterviewerMenu() : null,
  ];

  return (
    <Spin
      tip="Logging out …"
      indicator={<LoadingOutlined spin />}
      spinning={signOutLoading}
    >
      <a className={styles.skipLink} href="#workspace-main-content">
        Skip to main content
      </a>

      <Layout className={`${styles.root} backoffice-workspace`}>
        {authUser && (
          <Sider
            id="workspace-navigation-drawer"
            aria-label="Workspace navigation"
            width={264}
            collapsedWidth={80}
            collapsible
            collapsed={menu.collapsed}
            onCollapse={onCollapse}
            className={`${styles.sidebar} ${
              mobileNavigationOpen ? styles.sidebarOpen : ''
            }`}
          >
            <Link to="/" className={styles.logoWrapper}>
              <div className={styles.logo} aria-label="Home" />
            </Link>

            <Button
              type="text"
              aria-label="Close menu"
              className={styles.mobileClose}
              icon={<CloseOutlined />}
              onClick={() => {
                setMobileNavigationOpen(false);
                mobileNavigationToggleRef.current?.focus();
              }}
            />

            <WorkspaceNavigation searchInputRef={navigationSearchRef}>
              {availableNavigation}
            </WorkspaceNavigation>

            <BackTop aria-label="scroll top" className={styles.backTopCta}>
              <div className={styles.backTopCtaIconWrapper}>
                <ArrowUpOutlined />
              </div>
            </BackTop>
          </Sider>
        )}

        {authUser && mobileNavigationOpen && (
          <button
            type="button"
            aria-label="Dismiss navigation"
            className={styles.sidebarBackdrop}
            onClick={() => {
              setMobileNavigationOpen(false);
              mobileNavigationToggleRef.current?.focus();
            }}
          />
        )}

        <Layout id={LAYOUT_ID} className={styles.workspaceBody}>
          <Header
            className={`${styles.header} ${
              authUser ? '' : styles.headerSignedOut
            }`}
          >
            {authUser ? (
              <>
                <div className={styles.headerIdentity}>
                  <Button
                    ref={mobileNavigationToggleRef}
                    type="text"
                    aria-label={
                      mobileNavigationOpen
                        ? 'Close navigation'
                        : 'Open navigation'
                    }
                    aria-controls="workspace-navigation-drawer"
                    aria-expanded={mobileNavigationOpen}
                    className={styles.mobileNavigationToggle}
                    onClick={() => {
                      if (mobileNavigationOpen) {
                        setMobileNavigationOpen(false);
                        mobileNavigationToggleRef.current?.focus();
                      } else {
                        updateMenu({ collapsed: false });
                        setMobileNavigationOpen(true);
                      }
                    }}
                  >
                    <MenuOutlined aria-hidden="true" />
                  </Button>

                  <div className={styles.pageIdentity}>
                    {/* "Workspace / Dashboard" above a "Dashboard" heading says
                        nothing twice, so the trail appears only where the page
                        actually sits inside a record. */}
                    {hasContextualBackNavigation && (
                      <nav
                        aria-label="Breadcrumb"
                        className={styles.breadcrumbs}
                      >
                        <span>{breadcrumbParent}</span>
                        <span aria-hidden="true">/</span>
                        <span aria-current="page">{pageTitle}</span>
                      </nav>
                    )}

                    <div className={styles.pageTitleRow}>
                      {!isDesigner &&
                        !isModerator &&
                        hasContextualBackNavigation && (
                          <Button
                            type="text"
                            className={styles.backButton}
                            onClick={handleGoBack}
                          >
                            <RollbackOutlined />
                            Back
                          </Button>
                        )}

                      <Title level={3} className={styles.title}>
                        {pageTitle}
                      </Title>
                    </div>
                  </div>
                </div>

                <Space
                  direction="horizontal"
                  size="small"
                  align="center"
                  className={styles.accountActions}
                >
                  <Button
                    type="text"
                    className={styles.headerAction}
                    onClick={handleGoToAccountPage}
                  >
                    Account
                  </Button>

                  <Button
                    type="text"
                    className={styles.headerAction}
                    onClick={handleLogout}
                  >
                    Log out
                  </Button>
                </Space>
              </>
            ) : (
              <div className={styles.logo} aria-label="Millions.co logo" />
            )}
          </Header>

          <Content
            id="workspace-main-content"
            role="main"
            tabIndex={-1}
            className={styles.content}
          >
            {authUser ? (
              children
            ) : (
              <LoginForm
                title="Log in to continue"
                subTitle="Use your admin account"
              />
            )}
          </Content>
        </Layout>
      </Layout>
    </Spin>
  );
};
